<template>
	<div class="page-main" style="position: relative;" :id="backtop_id">
		<div class="sign_up_container" style="width: 1200px; display: flex; flex-direction: column;" v-if="page_index == 1">
			<!-- 报名 -->
			<div style="display: inline-flex; flex-direction: column; width: 1200px;  z-index: 3;">
				<div style="display: flex; margin: 70px 0 40px 0;">
					<div style="margin-right: 10px;width: 5px;background: linear-gradient(to bottom,#ff9000,#c93a2e);">
					</div>
					<div style="display: flex;flex-direction: column; line-height: 1;font-size: 28px; color: #333;">
						报名
					</div>
				</div>
			</div>
			
			<!-- 黑名单用户显示-->
			<div v-if="detailData && detailData.is_black == 1" style=" display: flex;flex-direction: column; justify-content: center; align-items: center; font-size: 18px; min-height: 75vh ; background-color: #fff; box-shadow: 1px 2px 1px #eee; border-radius: 15px; padding:35px; margin-bottom: 60px; line-height: 1;">
				抱歉，您的账号已被标记为可疑账号，暂无法报名，如需解封请联系客服经理。
			</div>
			
			<!-- 正常用户显示 -->
			<div v-if="detailData && detailData.is_black == 0" style="display: flex;flex-direction: column; background-color: #fff; box-shadow: 1px 2px 1px #eee; border-radius: 15px; padding: 35px; margin-bottom: 60px; ;line-height: 1;">
				<div style="display: flex; justify-content: space-between;padding-bottom: 22px; border-bottom: 1px solid #eee;">
					<div style="display: flex; flex-direction: column;font-size: 18px; color: #333;">
						<div style="font-weight: 600;">项目</div>
						<div style="margin-top: 40px;">{{detailData.title}}</div>
					</div>
					<div style="display: flex; flex-direction: column; justify-content: flex-end;" v-if="price">
						<div style="font-size: 12px; color: #ff9000;">总计</div>
						<div style="font-size: 18px; color: #333; margin-top: 24px;">{{price}} x {{gift_count}} = ￥{{total_fee}}</div>
					</div>
				</div>

				<div style="display: flex;flex-direction: column;">
					<div style="font-size: 18px;color: #333;font-weight: 600; padding: 40px 0;">
						个人信息
					</div>
					
					<div style="display: inline-block; width: 640px;">
						<el-form :model="dynamicValidateForm" ref="dynamicValidateForm" label-width="240px">
						
							<div v-for="(domain, index) in dynamicValidateForm.domains" :key="domain.key">
								
								
								<div style="display: flex; align-items: center;">
									<el-divider content-position="left" v-if="index>0">报名人员 +{{index}}</el-divider>
									
									<el-divider content-position="right" v-if="index>0">
									<span @click.prevent="removeDomain(domain)" style="cursor: pointer;">移除 <i class="el-icon-delete"></i></span>
									</el-divider>
								</div>
								
								<div v-if="id!='t_096c479feb0c4562906eb7ab18b25892' 
								&& id!='t_c9b3426056534835bf99ed82d4722df3' 
								&& id!='t_0a30bf778763435dabdbb2ca67569fb7' 
								&& id!='t_c14ccdb632ea4a9c98f072cf539221a3' 
								&& id!='t_1dcf1deb1d654ade8066e3bb167fc02b' ">
									<el-form-item :prop="'domains.' + index + '.name'"  label="姓名" :rules="[{ required: true, message: '请输入姓名', trigger: ['blur', 'change'] }]">
										<el-input v-model="domain.name" placeholder="请输入姓名"></el-input>
									</el-form-item>
									
									<el-form-item :prop="'domains.' + index + '.sex'" label="性别" :rules="[{ required: true, message: '请选择性别', trigger: 'change' }]">
										<el-radio-group v-model="domain.sex">
											  <el-radio label="男"></el-radio>
											  <el-radio label="女"></el-radio>
											</el-radio-group>
									</el-form-item>
									
									<el-form-item :prop="'domains.' + index + '.mobile'" label="手机" :rules="[{ required: true, message: '请输入手机号码', trigger: ['blur', 'change'] },{ pattern: /^[1][3-9][0-9]{9}$/, message: '请输入正确的手机号码', trigger: ['blur', 'change'] }]">
										<el-input @blur="inputMobileBlurEvent" v-model="domain.mobile" placeholder="请输入手机号码"></el-input>
									</el-form-item>
									
									<el-form-item :prop="'domains.' + index + '.email'" label="邮箱" :rules="[{ required: true, message: '请输入邮箱地址', trigger: ['blur', 'change'] },{ type: 'email', message: '请输入正确的邮箱地址', trigger: ['blur', 'change'] }]">
										<el-input @blur="inputEmailBlurEvent" v-model="domain.email" placeholder="请输入邮箱地址" ></el-input>
									</el-form-item>
									
									<el-form-item :prop="'domains.' + index + '.wechat_id'" label="微信号" :rules="[{ required: true, message: '请输入微信号', trigger: ['blur', 'change'] }]">
										<el-input v-model="domain.wechat_id" placeholder="为了方便建立会议群，请您提供微信号"></el-input>
									</el-form-item>
									
									
									<el-form-item :prop="'domains.' + index + '.job_type'" label="身份" :rules="[{ required: true, message: '请选择身份类型', trigger: 'change' }]">
										<!-- <el-radio-group v-model="domain.job_type" @input="jobTypeChangeEvent" :disabled="domain.job_type_disabled">
											<el-radio label="教师"></el-radio>
											<el-radio label="学生"></el-radio>
											<el-radio label="其他"></el-radio>
										</el-radio-group> -->
										
										<el-radio-group v-model="domain.job_type" @input="jobTypeChangeEvent"
											:disabled="domain.job_type_disabled" >
											<el-radio :label="job_type_item" v-for="job_type_item in detailData.job_type_items"></el-radio>
										</el-radio-group>
									</el-form-item>
									
									<el-form-item v-if="domain.job_type == '教师' || domain.job_type == '学生'" :prop="'domains.' + index + '.school'" label="学校" :rules="[ { required: true, message: '请输入学校', trigger: ['blur', 'change'] }]">
										<el-input v-model="domain.school" placeholder="请输入学校"></el-input>
									</el-form-item>
									<el-form-item v-if="domain.job_type == '教师' || domain.job_type == '学生'" :prop="'domains.' + index + '.college'" label="院系" :rules="[ { required: true, message: '请输入院系', trigger: ['blur', 'change'] }]">
										<el-input v-model="domain.college" placeholder="请输入院系"></el-input>
									</el-form-item>
									<el-form-item v-if="detailData.is_simple_info == 0  && domain.job_type == '教师'" :prop="'domains.' + index + '.course'" label="课程" :rules="[ { required: true, message: '请输入所授课程', trigger: ['blur', 'change'] }]">
										<el-input v-model="domain.course" placeholder="请输入所授课程"></el-input>
									</el-form-item>
									
									<el-form-item v-if="domain.job_type == '其他'" :prop="'domains.' + index + '.company'" label="公司(单位)名称" :rules="[ { required: true, message: '请输入公司或单位名称', trigger: ['blur', 'change'] }]">
										<el-input v-model="domain.company" placeholder="请输入公司(单位)名称"></el-input>
									</el-form-item>
									<el-form-item v-if="domain.job_type == '其他'" :prop="'domains.' + index + '.department'"
										label="公司(单位)部门"
										:rules="[ { required: true, message: '请输入公司或单位部门名称', trigger: ['blur', 'change'] }]">
										<el-input v-model="domain.department" placeholder="请输入公司(单位)部门名称"></el-input>
									</el-form-item>
									
									<el-form-item v-if="domain.job_type == '教师' || (id=='t_4563add01cf44b47a1a0bfab4e1043ea' && domain.job_type == '其他')" :prop="'domains.' + index + '.title'" label="职称" :rules="[ { required: true, message: '请输入职称', trigger: ['blur', 'change'] }]">
										<el-input v-model="domain.title" placeholder="请输入职称"></el-input>
									</el-form-item>
									
									<el-form-item v-if="domain.job_type == '教师' || domain.job_type == '其他'" :prop="'domains.' + index + '.duty'" label="职务" :rules="[ { required: true, message: '请输入职务', trigger: ['blur', 'change'] }]">
										<el-input v-model="domain.duty" placeholder="请输入职务"></el-input>
									</el-form-item>
									<el-form-item v-if="detailData.is_simple_info == 0  && domain.job_type == '教师'" :prop="'domains.' + index + '.teaching_length'" label="教龄" :rules="[{ required: true, message: '请输入教龄', trigger: ['blur', 'change'] },{ type: 'number', message: '教龄必须为数字类型', trigger: ['blur', 'change']}]">
										<el-input v-model.number="domain.teaching_length" placeholder="请输入教龄"></el-input>
									</el-form-item>
									
									<el-form-item v-if="detailData.is_simple_info == 0  && (domain.job_type == '学生' || domain.job_type == '其他')" :prop="'domains.' + index + '.education'" label="学历" :rules="[{ required: true, message: '请选择学历', trigger: 'change' }]">
										<el-radio-group v-model="domain.education">
											<el-radio label="专科"></el-radio>
											<el-radio label="本科"></el-radio>
											<el-radio label="硕士"></el-radio>
											<el-radio label="博士"></el-radio>
										</el-radio-group>
									</el-form-item>
									
									<!-- 是否报告 -->
									<el-form-item v-if="detailData.has_report == 1" :prop="'domains.' + index + '.is_report'" label="是否有做报告意向" :rules="[{ required: true, message: '请选择', trigger: 'change' }]">
										<el-radio-group v-model="domain.is_report">
											<el-radio label="是"></el-radio>
											<el-radio label="否"></el-radio>
										 </el-radio-group>
									</el-form-item>
									
									<!-- 报告名称 -->
									<el-form-item v-if="domain.is_report == '是'" :prop="'domains.' + index + '.report_title'" label="报告名称" :rules="[ { required: true, message: '请输入报名名称', trigger: ['blur', 'change'] }]">
										<el-input v-model="domain.report_title" placeholder="请输入报告名称"></el-input>
									</el-form-item>
									
									
									<!-- 2026年汽车服务工程专业委员会年会暨面向AI与智能车辆发展专业建设研讨会 -->
									<div v-if="id=='t_b2e6a291c3414761b37c1428124b297d'">
										
										<!-- 报告时长 -->
										<el-form-item v-if="domain.is_report == '是'" :prop="'domains.' + index + '.report_duration'" label="报告时长" :rules="[{ required: true, message: '请输入报告时长（分钟数）', trigger: ['blur', 'change'] },{ type: 'number', message: '报告时长必须为数字类型', trigger: ['blur', 'change']}]">
											<el-input v-model.number="domain.report_duration" placeholder="请输入报告时长（分钟数）"></el-input>
										</el-form-item>
										
										<!-- 报告时间 -->
										<el-form-item v-if="domain.is_report == '是'" :prop="'domains.' + index + '.report_date'" label="报告时间" :rules="[ { required: true, message: '请输入报告时间', trigger: ['blur', 'change'] }]">
											<!-- <el-input v-model="domain.report_date" placeholder="请输入报告时间（几月几日作报告）"></el-input> -->
											<el-date-picker
												  v-model="domain.report_date"
												  type="datetime"
												  placeholder="请选择报告时间"
												  format="yyyy-MM-dd HH:mm:ss"
												  value-format="yyyy-MM-dd HH:mm:ss"
												   popper-class="report_date"
												  :default-value="defaultReportDate"
												  :picker-options="pickerOptions">
											</el-date-picker>
										</el-form-item>
										
										<!-- 报告顺序 -->
										<el-form-item v-if="domain.is_report == '是'" :prop="'domains.' + index + '.report_order_by'" label="报告顺序" :rules="[ { required: true, message: '请输入报告顺序（第几个作报告）', trigger: ['blur', 'change'] }, { type: 'number', message: '报告顺序必须为数字类型', trigger: ['blur', 'change']}]">
											<el-input v-model.number="domain.report_order_by" placeholder="请输入报告顺序（第几个作报告）"></el-input>
										</el-form-item>
									
									</div>
									
									<!-- 中国机械工业教育协会智慧水利专业委员会成立大会暨第一届青年教师智慧水利教学比赛 -->
									<!-- 
									<el-form-item v-if="id == 't_4563add01cf44b47a1a0bfab4e1043ea'" :prop="'domains.' + index + '.is_join_competition'" label="是否参加教学比赛" :rules="[{ required: true, message: '请选择', trigger: 'change' }]">
										<el-radio-group v-model="domain.is_join_competition">
											<el-radio label="是"></el-radio>
											<el-radio label="否"></el-radio>
										 </el-radio-group>
									</el-form-item> 
									-->
									
								</div>
								
								<!-- 中国机械工业教育协会智慧水利专业委员会成立大会暨第一届青年教师智慧水利教学比赛 -->
								<div v-if="id == 't_4563add01cf44b47a1a0bfab4e1043ea' && domain.is_join_competition == '是' ">
									<div style=" padding:5px 0 10px 120px; box-sizing: border-box;">
										<el-divider content-position="left">参赛信息</el-divider>
									</div>
									
									<el-form-item :prop="'domains.' + index + '.birth'"  label="出生年月" :rules="[{ required: true, message: '请选择出生年月', trigger: ['blur', 'change'] }]">
										<el-date-picker v-model="domain.birth" type="month" default-value="1980-01" placeholder="选择出生年月"> </el-date-picker>
									</el-form-item>
									
									<el-form-item :prop="'domains.' + index + '.education'" label="学历" :rules="[{ required: true, message: '请选择学历', trigger: 'change' }]">
										<el-radio-group v-model="domain.education">
											<el-radio label="专科"></el-radio>
											<el-radio label="本科"></el-radio>
											<el-radio label="硕士"></el-radio>
											<el-radio label="博士"></el-radio>
										</el-radio-group>
									</el-form-item>
									
									<el-form-item label="通讯地址" required>		
										<el-col :span="24">
										  <el-form-item :prop="'domains.' + index + '.pca'" :rules="[{ required: true, message: '请选择省/市/区（县）', trigger: ['blur', 'change']}]">
											<el-cascader placeholder="请选择省/市/区（县）" :options="options" v-model="domain.pca"  :props="{label:'name',value:'name',children:'children' }" filterable ></el-cascader>
										  </el-form-item>
										</el-col>
										<el-col :span="24">
										  <el-form-item :prop="'domains.' + index + '.address'" :rules="[{ required: true, message: '请输入详情地址', trigger: ['blur', 'change']}]">
											<el-input v-model="domain.address" placeholder="请输入详细地址"></el-input>
										  </el-form-item>
										</el-col>
									</el-form-item> 
									
									<el-form-item :prop="'domains.' + index + '.competition_group'" label="参赛组别" :rules="[{ required: true, message: '请选择参赛组别', trigger: 'change' }]">
										<el-radio-group v-model="domain.competition_group">
											<el-radio label="A组（985、211高校）"></el-radio>
											<el-radio label="B组（其他本科院校）"></el-radio>
											<el-radio label="C组（专科及职业技术院校）"></el-radio>
										</el-radio-group>
									</el-form-item>
									
									<el-form-item :prop="'domains.' + index + '.competition_course'" label="参赛课程" :rules="[ { required: true, message: '请输入参赛课程名称', trigger: ['blur', 'change'] }]">
										<el-input v-model="domain.competition_course" placeholder="请输入参赛课程名称"></el-input>
									</el-form-item>
									
									<el-form-item :prop="'domains.' + index + '.competition_course_type'" label="课程类型" :rules="[{ required: true, message: '请选择课程类型', trigger: 'change' }]">
										<el-radio-group v-model="domain.competition_course_type">
											<el-radio label="课堂教学"></el-radio>
											<el-radio label="实验教学"></el-radio>
											<el-radio label="案例教学"></el-radio>
											<el-radio label="习题课"></el-radio>
											<el-radio label="其他"></el-radio>
										</el-radio-group>
									</el-form-item>
									
									<el-form-item v-if="domain.competition_course_type == '其他'" :prop="'domains.' + index + '.competition_course_type_other'" label="其他课程类型" :rules="[ { required: true, message: '请输入其他课程类型', trigger: ['blur', 'change'] }]">
										<el-input v-model="domain.competition_course_type_other" placeholder="请输入其他课程类型"></el-input>
									</el-form-item>
									
									<el-form-item :prop="'domains.' + index + '.competition_teaching_clip_1'" label="教学片段一" :rules="[ { required: true, message: '请输入', trigger: ['blur', 'change'] }]">
										<el-input v-model="domain.competition_teaching_clip_1" placeholder="请输入章节/知识单元名称"></el-input>
									</el-form-item>
									
									<el-form-item :prop="'domains.' + index + '.competition_teaching_clip_2'" label="教学片段二" :rules="[ { required: true, message: '请输入', trigger: ['blur', 'change'] }]">
										<el-input v-model="domain.competition_teaching_clip_2" placeholder="请输入章节/知识单元名称"></el-input>
									</el-form-item>
									
									<el-form-item :prop="'domains.' + index + '.competition_teaching_portfolio'" label="教学简历与成果" :rules="[ { required: true, message: '请输入', trigger: ['blur', 'change'] }]">
										<el-input type="textarea" v-model="domain.competition_teaching_portfolio" placeholder="（主讲课程、教学改革与教学获奖情况等，200字以内）" :autosize="{ minRows: 3, maxRows: 9 }" maxlength="200" show-word-limit></el-input>
									</el-form-item>
									
									
								</div>
								
								
								<!-- 机械工业出版社2026年度数字课程项目开发邀请 -->
								<div v-if="id=='t_1dcf1deb1d654ade8066e3bb167fc02b' ">
									<el-form-item :prop="'domains.' + index + '.name'"  label="姓名" :rules="[{ required: true, message: '请输入姓名', trigger: ['blur', 'change'] }]">
										<el-input v-model="domain.name" placeholder="请输入姓名"></el-input>
									</el-form-item>
									
									<el-form-item :prop="'domains.' + index + '.mobile'" label="手机" :rules="[{ required: true, message: '请输入手机号码', trigger: ['blur', 'change'] },{ pattern: /^[1][3-9][0-9]{9}$/, message: '请输入正确的手机号码', trigger: ['blur', 'change'] }]">
										<el-input @blur="inputMobileBlurEvent" v-model="domain.mobile" placeholder="请输入手机号码"></el-input>
									</el-form-item>
									
									<el-form-item :prop="'domains.' + index + '.email'" label="邮箱" :rules="[{ type: 'email', message: '请输入正确的邮箱地址', trigger: ['blur', 'change'] }]">
										<el-input @blur="inputEmailBlurEvent" v-model="domain.email" placeholder="请输入邮箱地址" ></el-input>
									</el-form-item>
									
									<el-form-item :prop="'domains.' + index + '.job_type'" label="身份" :rules="[{ required: true, message: '请选择身份类型', trigger: 'change' }]">
										<el-radio-group v-model="domain.job_type" @input="jobTypeChangeEvent" :disabled="domain.job_type_disabled">
											<el-radio label="教师"></el-radio>
											<el-radio label="技术人员"></el-radio>
										</el-radio-group>
									</el-form-item>
									
									<el-form-item v-if="domain.job_type == '教师'" :prop="'domains.' + index + '.school'" label="学校" :rules="[ { required: true, message: '请输入学校', trigger: ['blur', 'change'] }]">
										<el-input v-model="domain.school" placeholder="请输入学校"></el-input>
									</el-form-item>
									
									<el-form-item v-if="domain.job_type == '教师'" :prop="'domains.' + index + '.title'" label="职称">
										<el-input v-model="domain.title" placeholder="请输入职称"></el-input>
									</el-form-item>
									
									<el-form-item v-if="domain.job_type == '技术人员'" :prop="'domains.' + index + '.company'" label="公司(单位)名称" :rules="[ { required: true, message: '请输入公司或单位名称', trigger: ['blur', 'change'] }]">
										<el-input v-model="domain.company" placeholder="请输入公司(单位)名称"></el-input>
									</el-form-item>

									<el-form-item v-if="domain.job_type == '教师' || domain.job_type == '技术人员'" :prop="'domains.' + index + '.duty'" label="职务">
										<el-input v-model="domain.duty" placeholder="请输入职务"></el-input>
									</el-form-item>

									<el-form-item :prop="'domains.' + index + '.course'" label="课程" :rules="[ { required: true, message: '请输入课程名称', trigger: ['blur', 'change'] }]">
										<el-input v-model="domain.course" placeholder="请输入课程名称"></el-input>
									</el-form-item>
									
									<el-form-item :prop="'domains.' + index + '.topic'" label="所属选题方向" :rules="[{ required: true, message: '请选择', trigger: 'change' }]">
										<el-radio-group v-model="domain.topic">
											<el-radio label="AI方向"></el-radio>
											<el-radio label="制造业方向"></el-radio>
											<el-radio label="信创方向"></el-radio>
											<el-radio label="其他"></el-radio>
										</el-radio-group>
									</el-form-item>
									
									<el-form-item v-if="domain.topic == '其他'" :prop="'domains.' + index + '.topic_other'" label="其他选题方向" :rules="[ { required: true, message: '请输入', trigger: ['blur', 'change'] }]">
										<el-input v-model="domain.topic_other" placeholder="请输入其他选题方向"></el-input>
									</el-form-item>
									
									<el-form-item :prop="'domains.' + index + '.target'" label="目标受众" :rules="[{ required: true, message: '请选择', trigger: 'change' }]">
										<el-radio-group v-model="domain.target">
											<el-radio label="企业管理层"></el-radio>
											<el-radio label="技术人员"></el-radio>
										</el-radio-group>
									</el-form-item>
									
									<el-form-item :prop="'domains.' + index + '.is_recorded'" label="录课经历" :rules="[{ required: true, message: '请选择', trigger: 'change' }]">
										<el-radio-group v-model="domain.is_recorded">
											<el-radio label="是"></el-radio>
											<el-radio label="否"></el-radio>
										</el-radio-group>
									</el-form-item>
									
								</div>
								
								
								<div v-if="id=='t_c14ccdb632ea4a9c98f072cf539221a3' ">
									<el-form-item :prop="'domains.' + index + '.name'"  label="姓名" :rules="[{ required: true, message: '请输入姓名', trigger: ['blur', 'change'] }]">
										<el-input v-model="domain.name" placeholder="请输入姓名"></el-input>
									</el-form-item>
									
									<el-form-item :prop="'domains.' + index + '.sex'" label="性别" :rules="[{ required: true, message: '请选择性别', trigger: 'change' }]">
										<el-radio-group v-model="domain.sex">
											  <el-radio label="男"></el-radio>
											  <el-radio label="女"></el-radio>
											</el-radio-group>
									</el-form-item>
									
									<el-form-item :prop="'domains.' + index + '.mobile'" label="手机" :rules="[{ required: true, message: '请输入手机号码', trigger: ['blur', 'change'] },{ pattern: /^[1][3-9][0-9]{9}$/, message: '请输入正确的手机号码', trigger: ['blur', 'change'] }]">
										<el-input @blur="inputMobileBlurEvent" v-model="domain.mobile" placeholder="请输入手机号码"></el-input>
									</el-form-item>
									
									<el-form-item :prop="'domains.' + index + '.email'" label="邮箱" :rules="[{ required: true, message: '请输入邮箱地址', trigger: ['blur', 'change'] },{ type: 'email', message: '请输入正确的邮箱地址', trigger: ['blur', 'change'] }]">
										<el-input @blur="inputEmailBlurEvent" v-model="domain.email" placeholder="请输入邮箱地址" ></el-input>
									</el-form-item>
									
									
									<el-form-item :prop="'domains.' + index + '.job_type'" label="身份" :rules="[{ required: true, message: '请选择身份类型', trigger: 'change' }]">
										<el-radio-group v-model="domain.job_type" @input="jobTypeChangeEvent" :disabled="domain.job_type_disabled">
											<el-radio label="高职教师"></el-radio>
											<el-radio label="本科教师"></el-radio>
											<el-radio label="企业人员"></el-radio>
										</el-radio-group>
									</el-form-item>
									
									<el-form-item v-if="domain.job_type == '高职教师' || domain.job_type == '本科教师'" :prop="'domains.' + index + '.school'" label="学校" :rules="[ { required: true, message: '请输入学校', trigger: ['blur', 'change'] }]">
										<el-input v-model="domain.school" placeholder="请输入学校"></el-input>
									</el-form-item>
									<el-form-item v-if="domain.job_type == '高职教师' || domain.job_type == '本科教师'" :prop="'domains.' + index + '.college'" label="院系" :rules="[ { required: true, message: '请输入院系', trigger: ['blur', 'change'] }]">
										<el-input v-model="domain.college" placeholder="请输入院系"></el-input>
									</el-form-item>
									
									<el-form-item v-if="domain.job_type == '高职教师' || domain.job_type == '本科教师'" :prop="'domains.' + index + '.title'" label="职称" :rules="[ { required: true, message: '请输入职称', trigger: ['blur', 'change'] }]">
										<el-input v-model="domain.title" placeholder="请输入职称"></el-input>
									</el-form-item>
									
									<el-form-item v-if="domain.job_type == '企业人员'" :prop="'domains.' + index + '.company'" label="公司(单位)名称" :rules="[ { required: true, message: '请输入公司或单位名称', trigger: ['blur', 'change'] }]">
										<el-input v-model="domain.company" placeholder="请输入公司(单位)名称"></el-input>
									</el-form-item>
									<el-form-item v-if="domain.job_type == '企业人员'" :prop="'domains.' + index + '.department'"
										label="公司(单位)部门"
										:rules="[ { required: true, message: '请输入公司或单位部门名称', trigger: ['blur', 'change'] }]">
										<el-input v-model="domain.department" placeholder="请输入公司(单位)部门名称"></el-input>
									</el-form-item>
									
									
									<el-form-item v-if="domain.job_type == '高职教师' || domain.job_type == '本科教师' || domain.job_type == '企业人员'" :prop="'domains.' + index + '.duty'" label="职务" :rules="[ { required: true, message: '请输入职务', trigger: ['blur', 'change'] }]">
										<el-input v-model="domain.duty" placeholder="请输入职务"></el-input>
									</el-form-item>
									
								</div>
								
								
								<div v-if="id=='t_0a30bf778763435dabdbb2ca67569fb7'">
									<el-form-item :prop="'domains.' + index + '.name'"  label="姓名" :rules="[{ required: true, message: '请输入姓名', trigger: ['blur', 'change'] }]">
										<el-input v-model="domain.name" placeholder="请输入姓名"></el-input>
									</el-form-item>
									
									<el-form-item :prop="'domains.' + index + '.sex'" label="性别" :rules="[{ required: true, message: '请选择性别', trigger: 'change' }]">
										<el-radio-group v-model="domain.sex">
											  <el-radio label="男"></el-radio>
											  <el-radio label="女"></el-radio>
											</el-radio-group>
									</el-form-item>
									
									<el-form-item :prop="'domains.' + index + '.mobile'" label="手机" :rules="[{ required: true, message: '请输入手机号码', trigger: ['blur', 'change'] },{ pattern: /^[1][3-9][0-9]{9}$/, message: '请输入正确的手机号码', trigger: ['blur', 'change'] }]">
										<el-input @blur="inputMobileBlurEvent" v-model="domain.mobile" placeholder="请输入手机号码"></el-input>
									</el-form-item>
									
									<el-form-item :prop="'domains.' + index + '.email'" label="邮箱" :rules="[{ required: true, message: '请输入邮箱地址', trigger: ['blur', 'change'] },{ type: 'email', message: '请输入正确的邮箱地址', trigger: ['blur', 'change'] }]">
										<el-input @blur="inputEmailBlurEvent" v-model="domain.email" placeholder="请输入邮箱地址" ></el-input>
									</el-form-item>
									
									<el-form-item :prop="'domains.' + index + '.major'" label="您要参与专题研讨的专业是" :rules="[{ required: true, message: '请选择专业', trigger: 'change' }]">
										<el-radio-group v-model="domain.major">
											<el-radio label="计算机/人工智能"></el-radio>
											<el-radio label="电子信息/集成电路"></el-radio>
											<el-radio label="机电/自动化"></el-radio>
										</el-radio-group>
									</el-form-item>
									
									<el-form-item :prop="'domains.' + index + '.job_type'" label="身份" :rules="[{ required: true, message: '请选择身份类型', trigger: 'change' }]">
										<el-radio-group v-model="domain.job_type" @input="jobTypeChangeEvent" :disabled="domain.job_type_disabled">
											<el-radio label="教师"></el-radio>
											<el-radio label="学生"></el-radio>
											<el-radio label="其他"></el-radio>
										</el-radio-group>
									</el-form-item>
									
									<el-form-item v-if="domain.job_type == '教师' || domain.job_type == '学生'" :prop="'domains.' + index + '.school'" label="学校" :rules="[ { required: true, message: '请输入学校', trigger: ['blur', 'change'] }]">
										<el-input v-model="domain.school" placeholder="请输入学校"></el-input>
									</el-form-item>
									<el-form-item v-if="domain.job_type == '教师' || domain.job_type == '学生'" :prop="'domains.' + index + '.college'" label="院系" :rules="[ { required: true, message: '请输入院系', trigger: ['blur', 'change'] }]">
										<el-input v-model="domain.college" placeholder="请输入院系"></el-input>
									</el-form-item>
									<el-form-item v-if="domain.job_type == '教师'" :prop="'domains.' + index + '.course'" label="课程" :rules="[ { required: true, message: '请输入所授课程', trigger: ['blur', 'change'] }]">
										<el-input v-model="domain.course" placeholder="请输入所授课程"></el-input>
									</el-form-item>
		
									
									<el-form-item v-if="domain.job_type == '其他'" :prop="'domains.' + index + '.company'" label="公司(单位)名称" :rules="[ { required: true, message: '请输入公司或单位名称', trigger: ['blur', 'change'] }]">
										<el-input v-model="domain.company" placeholder="请输入公司(单位)名称"></el-input>
									</el-form-item>
									<el-form-item v-if="domain.job_type == '其他'" :prop="'domains.' + index + '.department'"
										label="公司(单位)部门"
										:rules="[ { required: true, message: '请输入公司或单位部门名称', trigger: ['blur', 'change'] }]">
										<el-input v-model="domain.department" placeholder="请输入公司(单位)部门名称"></el-input>
									</el-form-item>
									
									
									<el-form-item v-if="domain.job_type == '教师' || domain.job_type == '其他'" :prop="'domains.' + index + '.duty'" label="职务" :rules="[ { required: true, message: '请输入职务', trigger: ['blur', 'change'] }]">
										<el-input v-model="domain.duty" placeholder="请输入职务"></el-input>
									</el-form-item>
		
									
									
									
									<el-form-item v-if="domain.job_type == '学生' || domain.job_type == '其他'" :prop="'domains.' + index + '.education'" label="学历" :rules="[{ required: true, message: '请选择学历', trigger: 'change' }]">
										<el-radio-group v-model="domain.education">
											<el-radio label="专科"></el-radio>
											<el-radio label="本科"></el-radio>
											<el-radio label="硕士"></el-radio>
											<el-radio label="博士"></el-radio>
										</el-radio-group>
									</el-form-item>
								</div>
								
								<div v-if="id =='t_096c479feb0c4562906eb7ab18b25892'">
									<el-form-item :prop="'domains.' + index + '.name'"  label="姓名" :rules="[{ required: true, message: '请输入姓名', trigger: ['blur', 'change'] }]">
										<el-input v-model="domain.name" placeholder="请输入姓名"></el-input>
									</el-form-item>
									
									<el-form-item :prop="'domains.' + index + '.job_type'" label="身份" :rules="[{ required: true, message: '请选择身份类型', trigger: 'change' }]">
										<el-radio-group v-model="domain.job_type" @input="jobTypeChangeEvent" :disabled="domain.job_type_disabled">
											<el-radio label="教师"></el-radio>
											<el-radio label="学生"></el-radio>
										</el-radio-group>
									</el-form-item>
									
									<el-form-item v-if="domain.job_type == '教师' || domain.job_type == '学生'" :prop="'domains.' + index + '.school'" label="学校" :rules="[ { required: true, message: '请输入学校', trigger: ['blur', 'change'] }]">
										<el-input v-model="domain.school" placeholder="请输入学校"></el-input>
									</el-form-item>
									<el-form-item v-if="domain.job_type == '教师' || domain.job_type == '学生'" :prop="'domains.' + index + '.college'" label="院系" :rules="[ { required: true, message: '请输入院系', trigger: ['blur', 'change'] }]">
										<el-input v-model="domain.college" placeholder="请输入院系"></el-input>
									</el-form-item>
									<el-form-item v-if="domain.job_type == '教师'" :prop="'domains.' + index + '.course'" label="课程" :rules="[ { required: true, message: '请输入所授课程', trigger: ['blur', 'change'] }]">
										<el-input v-model="domain.course" placeholder="请输入所授课程"></el-input>
									</el-form-item>
									<el-form-item v-if="domain.job_type == '教师'" :prop="'domains.' + index + '.title'" label="职称和职务" :rules="[ { required: true, message: '请输入职称', trigger: ['blur', 'change'] }]">
										<el-input v-model="domain.title" placeholder="请输入职称和职务"></el-input>
									</el-form-item>

									<el-form-item v-if="domain.job_type == '学生' || domain.job_type == '其他'" :prop="'domains.' + index + '.education'" label="学历" :rules="[{ required: true, message: '请选择学历', trigger: 'change' }]">
										<el-radio-group v-model="domain.education">
											<el-radio label="专科"></el-radio>
											<el-radio label="本科"></el-radio>
											<el-radio label="硕士"></el-radio>
											<el-radio label="博士"></el-radio>
										</el-radio-group>
									</el-form-item>
									
									<el-form-item :prop="'domains.' + index + '.mobile'" label="联系手机" :rules="[{ required: true, message: '请输入手机号码', trigger: ['blur', 'change'] },{ pattern: /^[1][3-9][0-9]{9}$/, message: '请输入正确的手机号码', trigger: ['blur', 'change'] }]">
										<el-input @blur="inputMobileBlurEvent" v-model="domain.mobile" placeholder="请输入手机号码"></el-input>
									</el-form-item>
									
									<el-form-item :prop="'domains.' + index + '.email'" label="联系邮箱" :rules="[{ required: true, message: '请输入邮箱地址', trigger: ['blur', 'change'] },{ type: 'email', message: '请输入正确的邮箱地址', trigger: ['blur', 'change'] }]">
										<el-input @blur="inputEmailBlurEvent" v-model="domain.email" placeholder="请输入邮箱地址" ></el-input>
									</el-form-item>
									
								</div>
								
								<div v-if="id =='t_c9b3426056534835bf99ed82d4722df3'">
									<el-form-item :prop="'domains.' + index + '.name'"  label="姓名" :rules="[{ required: true, message: '请输入姓名', trigger: ['blur', 'change'] }]">
										<el-input v-model="domain.name" placeholder="请输入姓名"></el-input>
									</el-form-item>
									
									<el-form-item :prop="'domains.' + index + '.sex'" label="性别" :rules="[{ required: true, message: '请选择性别', trigger: 'change' }]">
										<el-radio-group v-model="domain.sex">
											  <el-radio label="男"></el-radio>
											  <el-radio label="女"></el-radio>
											</el-radio-group>
									</el-form-item>
									
									<el-form-item :prop="'domains.' + index + '.mobile'" label="手机" :rules="[{ required: true, message: '请输入手机号码', trigger: ['blur', 'change'] },{ pattern: /^[1][3-9][0-9]{9}$/, message: '请输入正确的手机号码', trigger: ['blur', 'change'] }]">
										<el-input @blur="inputMobileBlurEvent" v-model="domain.mobile" placeholder="请输入手机号码"></el-input>
									</el-form-item>
									
									<el-form-item :prop="'domains.' + index + '.email'" label="邮箱" :rules="[{ required: true, message: '请输入邮箱地址', trigger: ['blur', 'change'] },{ type: 'email', message: '请输入正确的邮箱地址', trigger: ['blur', 'change'] }]">
										<el-input @blur="inputEmailBlurEvent" v-model="domain.email" placeholder="请输入邮箱地址" ></el-input>
									</el-form-item>
									
									
									<el-form-item :prop="'domains.' + index + '.job_type'" label="身份" :rules="[{ required: true, message: '请选择身份类型', trigger: 'change' }]">
										<el-radio-group v-model="domain.job_type" @input="jobTypeChangeEvent" :disabled="domain.job_type_disabled">
											<el-radio label="教师"></el-radio>
											<el-radio label="学生"></el-radio>
											<el-radio label="其他"></el-radio>
										</el-radio-group>
									</el-form-item>
									
									<el-form-item v-if="domain.job_type == '教师' || domain.job_type == '学生'" :prop="'domains.' + index + '.school'" label="学校" :rules="[ { required: true, message: '请输入学校', trigger: ['blur', 'change'] }]">
										<el-input v-model="domain.school" placeholder="请输入学校"></el-input>
									</el-form-item>
									<el-form-item v-if="domain.job_type == '教师' || domain.job_type == '学生'" :prop="'domains.' + index + '.college'" label="院系" :rules="[ { required: true, message: '请输入院系', trigger: ['blur', 'change'] }]">
										<el-input v-model="domain.college" placeholder="请输入院系"></el-input>
									</el-form-item>
									<el-form-item v-if="domain.job_type == '教师'" :prop="'domains.' + index + '.title'" label="职称" :rules="[ { required: true, message: '请输入职称', trigger: ['blur', 'change'] }]">
										<el-input v-model="domain.title" placeholder="请输入职称"></el-input>
									</el-form-item>
									
									<el-form-item v-if="domain.job_type == '其他'" :prop="'domains.' + index + '.company'" label="公司(单位)名称" :rules="[ { required: true, message: '请输入公司或单位名称', trigger: ['blur', 'change'] }]">
										<el-input v-model="domain.company" placeholder="请输入公司(单位)名称"></el-input>
									</el-form-item>
									<el-form-item v-if="domain.job_type == '其他'" :prop="'domains.' + index + '.department'"
										label="公司(单位)部门"
										:rules="[ { required: true, message: '请输入公司或单位部门名称', trigger: ['blur', 'change'] }]">
										<el-input v-model="domain.department" placeholder="请输入公司(单位)部门名称"></el-input>
									</el-form-item>
									<el-form-item v-if="domain.job_type == '其他'" :prop="'domains.' + index + '.duty'" label="职务" :rules="[ { required: true, message: '请输入职务', trigger: ['blur', 'change'] }]">
										<el-input v-model="domain.duty" placeholder="请输入职务"></el-input>
									</el-form-item>
									<el-form-item v-if="domain.job_type == '其他'" :prop="'domains.' + index + '.education'" label="学历" :rules="[{ required: true, message: '请选择学历', trigger: 'change' }]">
										<el-radio-group v-model="domain.education">
											<el-radio label="专科"></el-radio>
											<el-radio label="本科"></el-radio>
											<el-radio label="硕士"></el-radio>
											<el-radio label="博士"></el-radio>
										</el-radio-group>
									</el-form-item>
								</div>
					
								<!-- 其他会议的会议服务 -->
								<div v-if="id!='t_096c479feb0c4562906eb7ab18b25892' 
								&& id!='t_c9b3426056534835bf99ed82d4722df3' 
								&& id!='t_c14ccdb632ea4a9c98f072cf539221a3'
								&& detailData && detailData.case_type!=4">
									
								<div style=" padding:5px 0 10px 120px; box-sizing: border-box;">
									<el-divider content-position="left">会议服务选择</el-divider>
								</div>
								
								<el-form-item v-if="detailData.is_package==1"
									:prop="'domains.' + index + '.package_items'" label="参会"
									:rules="[{ required: true, message: '请选择您想要参加的会议', trigger: ['blur', 'change'] }]">
									<el-radio-group v-model="domain.package_items" style="margin-top:5px"
										@change="changePackageItems" :disabled="domain.package_items_disabled">
										<el-radio v-for="package_item in detailData.package_items" :label="package_item.id">
										{{package_item.title}} 
										<span v-if="package_item.price == '0.00'">（免费）</span>
										<span v-if="package_item.price != '0.00'">{{package_item.price}}</span>
										<span style="font-size: 12px; margin-left: 10px;">学生价：{{package_item.student_price}}</span>
										</el-radio>
									</el-radio-group>
								</el-form-item>
									
								<!-- 非纯线上 -->
								<div v-if="domain.is_show_more">
	
								<!-- 报到日期 -->
								<el-form-item v-if="detailData && detailData.has_arrival_date == 1 " :prop="'domains.' + index + '.check_in_date'" label="报到日期" :rules="[{ required: true, message: '请选择报到日期', trigger: ['blur', 'change'] }]">
									<el-date-picker
									      v-model="domain.check_in_date"
									      type="datetime"
									      placeholder="请选择报到日期"
										  format="yyyy-MM-dd HH:mm:ss"
										  value-format="yyyy-MM-dd HH:mm:ss"
										   popper-class="stay_days"
										  :default-value="defaultStartDate2"
										  :picker-options="pickerOptions">
									</el-date-picker>
								</el-form-item>
								
								
								<!-- <el-form-item v-if="domain.check_in_date == '其他'" :prop="'domains.' + index + '.check_in_date_other'" label="其他报到日期" :rules="[ { required: true, message: '请输入其他报道日期', trigger: ['blur', 'change'] }]">
									<el-input v-model="domain.check_in_date_other" placeholder="请输入其他报到日期"></el-input>
								</el-form-item> -->
								
								<!-- 会场报到车牌号码 -->
								<el-form-item v-if="domain.check_in_date && !isSameDay(domain.check_in_date,detailData.arrival_at) && detailData.has_arrival_plate_number == 1"
									:prop="'domains.' + index + '.check_in_plate_number'" label="车牌号码">
									<el-input v-model="domain.check_in_plate_number" placeholder="如自驾前往会场，请填写车牌号码"></el-input>
								</el-form-item>
								
								<!-- 餐饮 -->
								<!-- <el-form-item :prop="'domains.' + index + '.diet_type'" label="餐饮" :rules="[{ required: true, message: '请选择餐饮类型', trigger: 'change' }]">
									<el-radio-group v-model="domain.diet_type">
										<el-radio label="清真"></el-radio>
										<el-radio label="非清真"></el-radio>
									 </el-radio-group>
								</el-form-item> -->
								
								<!-- 用餐情况（单选）报到日晚餐 -->
								<el-form-item  v-if="detailData && detailData.has_dine == 1 && detailData.form_dine_label" :prop="'domains.' + index + '.is_dine'" :label="detailData.form_dine_label" :rules="[{ required: true, message: '请选择是否用餐', trigger: ['blur', 'change'] }]">
									<div style="line-height: 1.4;margin: 12px 0; color: #999;" v-if="detailData.form_dine_text" v-html="detailData.form_dine_text"></div>
									<el-radio-group v-model="domain.is_dine">
										<el-radio label="是"></el-radio>
										<el-radio label="否"></el-radio>
									</el-radio-group>
								</el-form-item>
								
								<!-- 用餐需求（多选） -->
								<el-form-item  v-if="detailData && detailData.has_dine_checkbox == 1 && detailData.form_dine_items && detailData.form_dine_items.length>0" :prop="'domains.' + index + '.dine_items'" label="用餐需求" :rules="[{ required: true, message: '请选择', trigger: ['blur', 'change'] }]">
									<el-checkbox-group v-model="domain.dine_items_arr" @change="dineCheckboxGroupChange($event,index)">
										<el-checkbox v-for="(tem,dex) in detailData.form_dine_items" :label="tem" ></el-checkbox>
									</el-checkbox-group>
								</el-form-item>
								
								<!-- 住宿安排 -->
								<el-form-item v-if="detailData && detailData.has_hotel == 1 && detailData.form_hotel_items" :prop="'domains.' + index + '.stay_type'" label="住宿" :rules="[{ required: true, message: '请选择住宿类型', trigger: 'change' }]">
									<el-radio-group v-model="domain.stay_type">
										<el-radio label="会务组代行预订"></el-radio>
										<el-radio label="自行安排"></el-radio>
									 </el-radio-group>
									 <div style="width: 260px; font-size: 12px; text-align: left;color: #C93A2E; margin-top: -18px; margin-left: 24px;">
										 具体以当日房价为准
									 </div>
								</el-form-item>
								
								<el-form-item v-if="detailData.form_hotel_items && domain.stay_type=='会务组代行预订'" :prop="'domains.' + index + '.hotel'" label="酒店" :rules="[{ required: true, message: '请选择您入住的酒店', trigger: ['blur', 'change'] }]">
									<el-radio-group v-model="domain.hotel">
										<el-radio :label="tem" v-for="(tem,dex) in detailData.form_hotel_items"></el-radio>
									</el-radio-group>
								</el-form-item>
								
								<el-form-item v-if="id!='t_b2e6a291c3414761b37c1428124b297d' && domain.hotel" :prop="'domains.' + index + '.room_type_before'" label="请选择房型" :rules="[{ required: true, message: '请选择房型', trigger: ['blur', 'change'] }]">
									<el-radio-group v-model="domain.room_type_before">
										<el-radio label="大床房"></el-radio>
										<el-radio label="标准间"></el-radio>
									</el-radio-group>
								</el-form-item>
								
								<el-form-item v-if="id=='t_b2e6a291c3414761b37c1428124b297d' && domain.hotel" :prop="'domains.' + index + '.room_type_before'" label="请选择房型" :rules="[{ required: true, message: '请选择房型', trigger: ['blur', 'change'] }]">
									<el-radio-group v-model="domain.room_type_before">
										<el-radio label="豪华大床房一500元/间/晚(含双早)"></el-radio>
										<el-radio label="豪华双床房一500元/间/晚(含双早)"></el-radio>
										<el-radio label="高级大床房一400元/间/晚(含单早)或450元/间/晚(含双早)"></el-radio>
										<el-radio label="高级双床房一400元/间/晚(含单早)或450元/间/晚(含双早)"></el-radio>
									</el-radio-group>
								</el-form-item>
								
								
								<el-form-item v-if="domain.hotel" :prop="'domains.' + index + '.room_type'" label="请选择入住方式" :rules="[{ required: true, message: '请选择入住方式', trigger: ['blur', 'change'] }]">
									<el-radio-group v-model="domain.room_type">
										<el-radio label="单人入住"></el-radio>
										<el-radio label="与指定人员拼房"></el-radio>
										<!-- <el-radio label="会务组随机拼房"></el-radio> -->
									</el-radio-group>
								</el-form-item>
								
								<el-form-item v-if="domain.room_type == '与指定人员拼房'" :prop="'domains.' + index + '.room_share_with'" label="同住人姓名/电话" :rules="[ { required: true, message: '请输入同住人姓名/电话', trigger: ['blur', 'change'] }]">
									<el-input v-model="domain.room_share_with" placeholder="请输入同住人姓名/电话"></el-input>
								</el-form-item>
								
								<!-- 入住及离店日期 -->
								<el-form-item v-if="domain.hotel" :prop="'domains.' + index + '.stay_days_arr'" label="入住及离店日期" :rules="[{ required: true, message: '请选择入住及离店日期', trigger: ['blur', 'change'] }]">
									<el-date-picker
									  v-model="domain.stay_days_arr"
									  type="daterange"
									  range-separator="至"
									  start-placeholder="入住日期"
									  end-placeholder="离店日期"
									  format="yyyy-MM-dd"
									  value-format="yyyy-MM-dd"
									  :default-value="defaultRangeDate"
									  :picker-options="pickerOptions"
									  popper-class="stay_days"
									  @change="stayDaysConfirmEvent($event,index)">
									</el-date-picker>
								</el-form-item>
								
								<!-- 参访 -->
								<el-form-item  v-if="detailData && detailData.has_visit == 1 && detailData.form_visit_label" :prop="'domains.' + index + '.is_visit'" :label="detailData.form_visit_label" :rules="[{ required: true, message: '请选择您是否参加参观考察', trigger: ['blur', 'change'] }]">
									<div style="line-height: 1.4;margin: 12px 0; color: #999;" v-if="detailData.form_visit_text" v-html="detailData.form_visit_text"></div>
									<el-radio-group v-model="domain.is_visit" v-if="detailData.has_visit_plate_number == 0">
										<el-radio label="是"></el-radio>
										<el-radio label="否"></el-radio>
									</el-radio-group>
									
									<el-radio-group @change="isVisitChangeEvent($event,index)"   v-model="domain.is_visit" v-if="detailData.has_visit_plate_number == 1">
										<el-radio label="是（统一安排）"></el-radio>
										<el-radio label="是（自行前往）"></el-radio>
										<el-radio label="否"></el-radio>
									</el-radio-group>
								</el-form-item>
								
								<!-- 参访车牌号码 -->
								<el-form-item v-if="domain.is_visit && domain.is_visit =='是（自行前往）'" :prop="'domains.' + index + '.visit_plate_number'" label="车牌号码">
									<el-input v-model="domain.visit_plate_number" placeholder="如自驾前往参访地，请填写车牌号码"></el-input>
								</el-form-item>
								
								</div>
								
								<!-- 考证 -->
								<el-form-item v-if="detailData && detailData.has_cert == 1 && detailData.form_cert_label" :prop="'domains.' + index + '.is_cert'" :label="detailData.form_cert_label"
									:rules="[{ required: true, message: '请选择是否考证', trigger: ['blur', 'change'] }]">
									<el-radio-group v-model="domain.is_cert" @input="isCertChangeEvent"
										:disabled="domain.is_cert_disabled">
										<el-radio label="是" v-if="detailData.cert_fee>0">是 (考证费 {{detailData.cert_fee}} 元)</el-radio>
										<el-radio label="是" v-if="detailData.cert_fee==0">是 (考证免费)</el-radio>
										<el-radio label="否"></el-radio>
									</el-radio-group>
								</el-form-item>
								
								<!-- 身份证号码 -->
								<el-form-item v-if="detailData &&  ((detailData.has_cert == 1 && domain.is_cert == '是') || (detailData.has_cert == 0 && detailData.has_id_card == 1))" :prop="'domains.' + index + '.id_card'" label="身份证号码"
									:rules="[{ required: true, message: '请输入身份证号码', trigger: ['blur', 'change'] },{ len:18,message: '请输入正确的身份证号码', trigger: ['blur', 'change'] }]">
									<div v-if="detailData.form_id_card_text" v-html="detailData.form_id_card_text" style="line-height: 1.4;margin: 12px 0;color: #999"></div>
									<el-input v-model="domain.id_card" placeholder="请输入身份证号码"></el-input>
								</el-form-item>
								
								<!-- 联系地址 -->
								<el-form-item label="联系地址" required v-if="detailData &&  ((detailData.has_cert == 1 && domain.is_cert == '是') || (detailData.has_cert == 0 && detailData.has_address == 1))">
									<div v-if="detailData.form_address_text" v-html="detailData.form_address_text" style="line-height: 1.4;margin: 12px 0;color: #999"></div>
			
									<el-col :span="24">
									  <el-form-item :prop="'domains.' + index + '.pca'" :rules="[{ required: true, message: '请选择省/市/区（县）', trigger: ['blur', 'change']}]">
										<el-cascader placeholder="请选择省/市/区（县）" :options="options" v-model="domain.pca"  :props="{label:'name',value:'name',children:'children' }" filterable ></el-cascader>
									  </el-form-item>
									</el-col>
									<el-col :span="24">
									  <el-form-item :prop="'domains.' + index + '.address'" :rules="[{ required: true, message: '请输入详情地址', trigger: ['blur', 'change']}]">
										<el-input v-model="domain.address" placeholder="请输入详细地址"></el-input>
									  </el-form-item>
									</el-col>
								</el-form-item> 
								
								<!-- 图片采集 -->
								<el-form-item :label="detailData.form_image_label" :prop="'domains.' + index + '.img'" v-if="detailData &&  ((detailData.has_cert == 1 && domain.is_cert == '是') || (detailData.has_cert == 0 && detailData.has_image == 1))">
									
									<div v-if="detailData.form_image_text" v-html="detailData.form_image_text"  style="line-height: 1.4;color: #999; margin-top: 10px; margin-bottom: -5px;"></div>
									<div class="pic2_box">
										<el-upload
											v-if="!domain.img_list || (domain.img_list && domain.img_list.length < detailData.form_image_limit)"
											:file-list="domain.img_list"
											accept=".jpg,.jpeg,.png,.bmp"
											action="#"
											drag
											multiple
											:auto-upload="false"
											:show-file-list="false"
											:limit="detailData.form_image_limit"
											:on-exceed="(files, fileList) => handleImgExceed2(files, fileList,index)"
											:on-change="(file, fileList) => handleImgChange2(file, fileList, index)"
										>
											<i class="el-icon-plus" style="margin-right: 8px;"></i>
											请选择或拖拽上传图片，限制每个5M以内
									  </el-upload>
									  
									  <div class="pic" v-if="domain.img_list" v-for="(tem,dex) in domain.img_list">
									  	<div class="image_box">
											<el-image 
											    class="image"
											    :src="tem.img_url_compressed" 
											    :preview-src-list="[tem.img_url_compressed]">
											  </el-image>
									  	</div>
									  	<div class="info">
									  		<div class="title">{{tem.title}}</div>
									  		<div class="exts" @click="delImgClick2(index,tem)">
									  			<div class="media_size">{{tem.media_size}}</div>
												<i class="el-icon-delete delicon"></i>
									  		</div>
									  	</div>
									  </div>
								
														
									</div>
								</el-form-item>
								
								<!-- 文件采集 -->
								<el-form-item :label="detailData.form_file_label" :prop="'domains.' + index + '.file'" v-if="detailData.has_file == 1">
									
									<div v-if="detailData.form_file_text" v-html="detailData.form_file_text"  style="line-height: 1.4;color: #999; margin-top: 10px; margin-bottom: -5px;"></div>
									<div class="pic2_box">
										<el-upload
											v-if="!domain.file_list || (domain.file_list && domain.file_list.length < detailData.form_file_limit)"
											:file-list="domain.file_list"
											accept=".txt,.pdf,.doc,.docx,.xls,.xlsx,.ppt,.pptx,.rar,.zip"
											action="#"
											drag
											multiple
											:auto-upload="false"
											:show-file-list="false"
											:limit="detailData.form_file_limit"
											:on-exceed="(files, fileList) => handleFileExceed2(files, fileList,index)"
											:on-change="(file, fileList) => handleFileChange2(file, fileList, index)"
										>
											<i class="el-icon-plus" style="margin-right: 8px;"></i>
											请选择或拖拽上传附件，限制每个5M以内
									  </el-upload>
									  
									  <div class="pic" v-if="domain.file_list" v-for="(tem,dex) in domain.file_list">
									  	<div class="image_box">
											  <img v-if="tem.media_ext == '.txt'" class="image file" src="https://images.cmptt.com/h5/media/cmptt/icon/icon_txt.png" />
											  <img v-if="tem.media_ext == '.pdf'" class="image file" src="https://images.cmptt.com/h5/media/cmptt/icon/icon_pdf.png" />
											  <img v-if="tem.media_ext == '.doc'" class="image file" src="https://images.cmptt.com/h5/media/cmptt/icon/icon_doc.png" />
									  		  <img v-if="tem.media_ext == '.docx'" class="image file" src="https://images.cmptt.com/h5/media/cmptt/icon/icon_docx.png" />
									  		  <img v-if="tem.media_ext == '.xls'" class="image file" src="https://images.cmptt.com/h5/media/cmptt/icon/icon_xls.png" />
									  		  <img v-if="tem.media_ext == '.xlsx'" class="image file" src="https://images.cmptt.com/h5/media/cmptt/icon/icon_xlsx.png" />
									  		  <img v-if="tem.media_ext == '.ppt'" class="image file" src="https://images.cmptt.com/h5/media/cmptt/icon/icon_ppt.png" />
									  		  <img v-if="tem.media_ext == '.pptx'" class="image file" src="https://images.cmptt.com/h5/media/cmptt/icon/icon_pptx.png" />
									  		  <img v-if="tem.media_ext == '.rar'" class="image file" src="https://images.cmptt.com/h5/media/cmptt/icon/icon_rar.png" />
											  <img v-if="tem.media_ext == '.zip'" class="image file" src="https://images.cmptt.com/h5/media/cmptt/icon/icon_zip.png" />
									  	</div>
									  	<div class="info">
									  		<div class="title">{{tem.title}}</div>
									  		<div class="exts" @click="delFileClick2(index,tem)">
									  			<div class="media_size">{{tem.media_size}}</div>
												<i class="el-icon-delete delicon"></i>
									  		</div>
									  	</div>
									  </div>
								
														
									</div>
								</el-form-item>
																
																
								
								</div>	
								
								
								<!-- 集成电路产教融合人才培养研讨会 -->
								<div v-if="id=='t_c14ccdb632ea4a9c98f072cf539221a3'">
									
								<div style=" padding:5px 0 10px 120px; box-sizing: border-box;">
									<el-divider content-position="left">会议服务选择</el-divider>
								</div>
								
								<el-form-item v-if="detailData.is_package==1"
									:prop="'domains.' + index + '.package_items'" label="参会"
									:rules="[{ required: true, message: '请选择您想要参加的会议', trigger: ['blur', 'change'] }]">
									<el-radio-group v-model="domain.package_items" style="margin-top:5px"
										@change="changePackageItems" :disabled="domain.package_items_disabled">
										<el-radio v-for="package_item in detailData.package_items" :label="package_item.id">{{package_item.title}} <span v-if="package_item.price == '0.00'">（免费）</span><span v-if="package_item.price != '0.00'">{{package_item.price}}</span></el-radio>
									</el-radio-group>
								</el-form-item>
									
								<!-- 非纯线上 -->
								<div v-if="domain.is_show_more">
									
								<el-form-item v-if="detailData && detailData.has_arrival_date == 1 " :prop="'domains.' + index + '.check_in_date'" label="报到日期" :rules="[{ required: true, message: '请选择报到日期', trigger: ['blur', 'change'] }]">
									<el-date-picker
									      v-model="domain.check_in_date"
									      type="date"
									      placeholder="请选择报到日期"
										  format="yyyy-MM-dd"
										  value-format="yyyy-MM-dd"
										   popper-class="stay_days"
										  :default-value="defaultStartDate"
										  :picker-options="pickerOptions">
									</el-date-picker>
								</el-form-item>
								
								
								<el-form-item  v-if="detailData && detailData.has_visit == 1 && detailData.form_visit_label" :prop="'domains.' + index + '.is_visit'" :label="detailData.form_visit_label" :rules="[{ required: true, message: '请选择您是否参加参观考察', trigger: ['blur', 'change'] }]">
									<div style="line-height: 1.4;margin: 12px 0; color: #999;" v-if="detailData.form_visit_text" v-html="detailData.form_visit_text"></div>
									<el-radio-group v-model="domain.is_visit">
										<el-radio label="是"></el-radio>
										<el-radio label="否"></el-radio>
									</el-radio-group>
								</el-form-item>
								
								<el-form-item :prop="'domains.' + index + '.interested'" label="参加以下哪一个分会场？" :rules="[{ required: true, message: '请选择', trigger: 'change' }]">
									<el-radio-group v-model="domain.interested">
										<el-radio label="高等教育产教融合人才培养"></el-radio>
										<!-- <el-radio label="高等职业教育产教融合人才培养"></el-radio> -->
										<el-radio label="AI赋能集成电路专业课程建设与改革"></el-radio>
									 </el-radio-group>
								</el-form-item>

								<el-form-item :prop="'domains.' + index + '.diet_type'" label="餐饮" :rules="[{ required: true, message: '请选择餐饮类型', trigger: 'change' }]">
									<el-radio-group v-model="domain.diet_type">
										<el-radio label="清真"></el-radio>
										<el-radio label="非清真"></el-radio>
									 </el-radio-group>
								</el-form-item>
								
								<el-form-item  v-if="detailData && detailData.has_dine == 1 && detailData.form_dine_label" :prop="'domains.' + index + '.is_dine'" :label="detailData.form_dine_label" :rules="[{ required: true, message: '请选择是否用餐', trigger: ['blur', 'change'] }]">
									<div style="line-height: 1.4;margin: 12px 0; color: #999;" v-if="detailData.form_dine_text" v-html="detailData.form_dine_text"></div>
									<el-radio-group v-model="domain.is_dine">
										<el-radio label="是"></el-radio>
										<el-radio label="否"></el-radio>
									</el-radio-group>
								</el-form-item>
								
								<el-form-item  v-if="detailData && detailData.has_dine == 1" :prop="'domains.' + index + '.is_dine2'" label="10月25日晚宴，是否用餐？" :rules="[{ required: true, message: '请选择是否用餐', trigger: ['blur', 'change'] }]">
									<el-radio-group v-model="domain.is_dine2">
										<el-radio label="是"></el-radio>
										<el-radio label="否"></el-radio>
									</el-radio-group>
								</el-form-item>
								
								<el-form-item v-if="detailData && detailData.has_hotel == 1 && detailData.form_hotel_items" :prop="'domains.' + index + '.stay_type'" label="住宿" :rules="[{ required: true, message: '请选择住宿类型', trigger: 'change' }]">
									<el-radio-group v-model="domain.stay_type">
										<el-radio label="会务组代行预订"></el-radio>
										<el-radio label="自行安排"></el-radio>
									 </el-radio-group>
									 <div style="width: 260px; font-size: 12px; text-align: left;color: #C93A2E; margin-top: -18px; margin-left: 24px;">
										 具体以当日房价为准
									 </div>
								</el-form-item>
								
								<el-form-item v-if="detailData.form_hotel_items && domain.stay_type=='会务组代行预订'" label="酒店" :prop="'domains.' + index + '.hotel'" :rules="[{ required: true, message: '请选择您入住的酒店', trigger: ['blur', 'change'] }]">
									<el-radio-group v-model="domain.hotel">
										<el-radio label="全季西安比亚迪高新厂酒店（300元/晚，含双早）" ></el-radio>
										<el-radio label="西安高新福朋喜来登酒店（已满，350元/晚，含双早）"  disabled></el-radio>
									</el-radio-group>
								</el-form-item>
								
								
								<el-form-item v-if="domain.stay_type=='会务组代行预订'" :prop="'domains.' + index + '.room_type'" label="请选择入住方式" :rules="[{ required: true, message: '请选择入住方式', trigger: ['blur', 'change'] }]">
									<el-radio-group v-model="domain.room_type">
										<el-radio label="单人入住"></el-radio>
										<el-radio label="与指定人员拼房"></el-radio>
										<el-radio label="会务组随机拼房"></el-radio>
									</el-radio-group>
								</el-form-item>
								
								<el-form-item v-if="domain.room_type == '与指定人员拼房'" :prop="'domains.' + index + '.room_share_with'" label="同住人姓名/电话" :rules="[ { required: true, message: '请输入同住人姓名/电话', trigger: ['blur', 'change'] }]">
									<el-input v-model="domain.room_share_with" placeholder="请输入同住人姓名/电话"></el-input>
								</el-form-item>
								
								
								<el-form-item v-if="domain.stay_type=='会务组代行预订'" :prop="'domains.' + index + '.stay_days_arr'" label="入住及离店日期" :rules="[{ required: true, message: '请选择入住及离店日期', trigger: ['blur', 'change'] }]">
									<el-date-picker
									  v-model="domain.stay_days_arr"
									  type="daterange"
									  range-separator="至"
									  start-placeholder="入住日期"
									  end-placeholder="离店日期"
									  format="yyyy-MM-dd"
									  value-format="yyyy-MM-dd"
									  :default-value="defaultRangeDate"
									  :picker-options="pickerOptions"
									  popper-class="stay_days"
									  @change="stayDaysConfirmEvent($event,index)">
									</el-date-picker>
								</el-form-item>
								
								
						
								
								</div>
								
								<el-form-item v-if="detailData && detailData.has_cert == 1 && detailData.form_cert_label" :prop="'domains.' + index + '.is_cert'" :label="detailData.form_cert_label"
									:rules="[{ required: true, message: '请选择是否考证', trigger: ['blur', 'change'] }]">
									<el-radio-group v-model="domain.is_cert" @input="isCertChangeEvent"
										:disabled="domain.is_cert_disabled">
										<el-radio label="是" v-if="detailData.cert_fee>0">是 (考证费 {{detailData.cert_fee}} 元)</el-radio>
										<el-radio label="是" v-if="detailData.cert_fee==0">是 (考证免费)</el-radio>
										<el-radio label="否"></el-radio>
									</el-radio-group>
								</el-form-item>
								
								<el-form-item v-if="detailData &&  ((detailData.has_cert == 1 && domain.is_cert == '是') || (detailData.has_cert == 0 && detailData.has_id_card == 1))" :prop="'domains.' + index + '.id_card'" label="身份证号码"
									:rules="[{ required: true, message: '请输入身份证号码', trigger: ['blur', 'change'] },{ len:18,message: '请输入正确的身份证号码', trigger: ['blur', 'change'] }]">
									<div v-if="detailData.form_id_card_text" v-html="detailData.form_id_card_text" style="line-height: 1.4;margin: 12px 0;color: #999"></div>
									<el-input v-model="domain.id_card" placeholder="请输入身份证号码"></el-input>
								</el-form-item>
								
								
								<el-form-item label="联系地址" required v-if="detailData &&  ((detailData.has_cert == 1 && domain.is_cert == '是') || (detailData.has_cert == 0 && detailData.has_address == 1))">
									<div v-if="detailData.form_address_text" v-html="detailData.form_address_text" style="line-height: 1.4;margin: 12px 0;color: #999"></div>
											
									<el-col :span="24">
									  <el-form-item :prop="'domains.' + index + '.pca'" :rules="[{ required: true, message: '请选择省/市/区（县）', trigger: ['blur', 'change']}]">
										<el-cascader placeholder="请选择省/市/区（县）" :options="options" v-model="domain.pca"  :props="{label:'name',value:'name',children:'children' }" filterable ></el-cascader>
									  </el-form-item>
									</el-col>
									<el-col :span="24">
									  <el-form-item :prop="'domains.' + index + '.address'" :rules="[{ required: true, message: '请输入详情地址', trigger: ['blur', 'change']}]">
										<el-input v-model="domain.address" placeholder="请输入详细地址"></el-input>
									  </el-form-item>
									</el-col>
								</el-form-item> 
								</div>
								
								
								<!-- AI驱动下的财务变革青年学者论坛暨《财务管理研究》青年编委会会议 -->
								<div v-if="id=='t_c9b3426056534835bf99ed82d4722df3'">
									
								<div style=" padding:5px 0 10px 120px; box-sizing: border-box;">
									<el-divider content-position="left">会议服务选择</el-divider>
								</div>
								
								<el-form-item v-if="detailData.is_package==1"
									:prop="'domains.' + index + '.package_items'" label="参会"
									:rules="[{ required: true, message: '请选择您想要参加的会议', trigger: ['blur', 'change'] }]">
									<el-radio-group v-model="domain.package_items" style="margin-top:5px"
										@change="changePackageItems" :disabled="domain.package_items_disabled">
										<el-radio v-for="package_item in detailData.package_items" :label="package_item.id">{{package_item.title}} <span v-if="package_item.price == '0.00'">（免费）</span><span v-if="package_item.price != '0.00'">{{package_item.price}}</span></el-radio>
									</el-radio-group>
								</el-form-item>
									
								<!-- 非纯线上 -->
								<div v-if="domain.is_show_more">
									
								<el-form-item v-if="detailData && detailData.has_arrival_date == 1 " :prop="'domains.' + index + '.check_in_date'" label="报到日期" :rules="[{ required: true, message: '请选择报到日期', trigger: ['blur', 'change'] }]">
									<el-date-picker
									      v-model="domain.check_in_date"
									      type="date"
									      placeholder="请选择报到日期"
										  format="yyyy-MM-dd"
										  value-format="yyyy-MM-dd"
										   popper-class="stay_days"
										  :default-value="defaultStartDate"
										  :picker-options="pickerOptions">
									</el-date-picker>
								</el-form-item>
								
								<el-form-item v-if="domain.check_in_date == '其他'" :prop="'domains.' + index + '.check_in_date_other'" label="其他报到日期" :rules="[ { required: true, message: '请输入其他报道日期', trigger: ['blur', 'change'] }]">
									<el-input v-model="domain.check_in_date_other" placeholder="请输入其他报到日期"></el-input>
								</el-form-item>
								
								<el-form-item :prop="'domains.' + index + '.diet_type'" label="餐饮" :rules="[{ required: true, message: '请选择餐饮类型', trigger: 'change' }]">
									<el-radio-group v-model="domain.diet_type">
										<el-radio label="清真"></el-radio>
										<el-radio label="非清真"></el-radio>
									 </el-radio-group>
								</el-form-item>
								
								<el-form-item  v-if="detailData && detailData.has_dine == 1 && detailData.form_dine_label" :prop="'domains.' + index + '.is_dine'" :label="detailData.form_dine_label" :rules="[{ required: true, message: '请选择是否用餐', trigger: ['blur', 'change'] }]">
									<div style="line-height: 1.4;margin: 12px 0; color: #999;" v-if="detailData.form_dine_text" v-html="detailData.form_dine_text"></div>
									<el-radio-group v-model="domain.is_dine">
										<el-radio label="是"></el-radio>
										<el-radio label="否"></el-radio>
									</el-radio-group>
								</el-form-item>
								
								<el-form-item v-if="detailData && detailData.has_hotel == 1 && detailData.form_hotel_items" :prop="'domains.' + index + '.stay_type'" label="住宿" :rules="[{ required: true, message: '请选择住宿类型', trigger: 'change' }]">
									<el-radio-group v-model="domain.stay_type">
										<el-radio label="会务组代行预订"></el-radio>
										<el-radio label="自行安排"></el-radio>
									 </el-radio-group>
									 <div style="width: 260px; font-size: 12px; text-align: left;color: #C93A2E; margin-top: -18px; margin-left: 24px;">
										 具体以当日房价为准
									 </div>
								</el-form-item>
								
								<el-form-item v-if="detailData.form_hotel_items && domain.stay_type=='会务组代行预订'" :prop="'domains.' + index + '.hotel'" label="酒店" :rules="[{ required: true, message: '请选择您入住的酒店', trigger: ['blur', 'change'] }]">
									<el-radio-group v-model="domain.hotel">
										<el-radio :label="tem" v-for="(tem,dex) in detailData.form_hotel_items"></el-radio>
									</el-radio-group>
								</el-form-item>
								
								
								<el-form-item v-if="domain.hotel" :prop="'domains.' + index + '.room_type'" label="请选择入住方式" :rules="[{ required: true, message: '请选择入住方式', trigger: ['blur', 'change'] }]">
									<el-radio-group v-model="domain.room_type">
										<el-radio label="单人入住"></el-radio>
										<el-radio label="会务组随机拼房"></el-radio>
									</el-radio-group>
								</el-form-item>
								

								<el-form-item v-if="domain.hotel" :prop="'domains.' + index + '.stay_days_arr'" label="入住及离店日期" :rules="[{ required: true, message: '请选择入住及离店日期', trigger: ['blur', 'change'] }]">
									<el-date-picker
									  v-model="domain.stay_days_arr"
									  type="daterange"
									  range-separator="至"
									  start-placeholder="入住日期"
									  end-placeholder="离店日期"
									  format="yyyy-MM-dd"
									  value-format="yyyy-MM-dd"
									  :default-value="defaultRangeDate"
									  :picker-options="pickerOptions"
									  popper-class="stay_days"
									  @change="stayDaysConfirmEvent($event,index)">
									</el-date-picker>
								</el-form-item>
								
								<el-form-item  v-if="detailData && detailData.has_visit == 1 && detailData.form_visit_label" :prop="'domains.' + index + '.is_visit'" :label="detailData.form_visit_label" :rules="[{ required: true, message: '请选择您是否参加参观考察', trigger: ['blur', 'change'] }]">
									<div style="line-height: 1.4;margin: 12px 0; color: #999;" v-if="detailData.form_visit_text" v-html="detailData.form_visit_text"></div>
									<el-radio-group v-model="domain.is_visit">
										<el-radio label="是"></el-radio>
										<el-radio label="否"></el-radio>
									</el-radio-group>
								</el-form-item>
								
								</div>
								
								<el-form-item v-if="detailData && detailData.has_cert == 1 && detailData.form_cert_label" :prop="'domains.' + index + '.is_cert'" :label="detailData.form_cert_label"
									:rules="[{ required: true, message: '请选择是否考证', trigger: ['blur', 'change'] }]">
									<el-radio-group v-model="domain.is_cert" @input="isCertChangeEvent"
										:disabled="domain.is_cert_disabled">
										<el-radio label="是" v-if="detailData.cert_fee>0">是 (考证费 {{detailData.cert_fee}} 元)</el-radio>
										<el-radio label="是" v-if="detailData.cert_fee==0">是 (考证免费)</el-radio>
										<el-radio label="否"></el-radio>
									</el-radio-group>
								</el-form-item>
								
								<el-form-item v-if="detailData &&  ((detailData.has_cert == 1 && domain.is_cert == '是') || (detailData.has_cert == 0 && detailData.has_id_card == 1))" :prop="'domains.' + index + '.id_card'" label="身份证号码"
									:rules="[{ required: true, message: '请输入身份证号码', trigger: ['blur', 'change'] },{ len:18,message: '请输入正确的身份证号码', trigger: ['blur', 'change'] }]">
									<div v-if="detailData.form_id_card_text" v-html="detailData.form_id_card_text" style="line-height: 1.4;margin: 12px 0;color: #999"></div>
									<el-input v-model="domain.id_card" placeholder="请输入身份证号码"></el-input>
								</el-form-item>
								
								
								<el-form-item label="联系地址" required v-if="detailData &&  ((detailData.has_cert == 1 && domain.is_cert == '是') || (detailData.has_cert == 0 && detailData.has_address == 1))">
									<div v-if="detailData.form_address_text" v-html="detailData.form_address_text" style="line-height: 1.4;margin: 12px 0;color: #999"></div>
											
									<el-col :span="24">
									  <el-form-item :prop="'domains.' + index + '.pca'" :rules="[{ required: true, message: '请选择省/市/区（县）', trigger: ['blur', 'change']}]">
										<el-cascader placeholder="请选择省/市/区（县）" :options="options" v-model="domain.pca"  :props="{label:'name',value:'name',children:'children' }" filterable ></el-cascader>
									  </el-form-item>
									</el-col>
									<el-col :span="24">
									  <el-form-item :prop="'domains.' + index + '.address'" :rules="[{ required: true, message: '请输入详情地址', trigger: ['blur', 'change']}]">
										<el-input v-model="domain.address" placeholder="请输入详细地址"></el-input>
									  </el-form-item>
									</el-col>
								</el-form-item>
								
								
								
								</div>	
							

							</div>
														
							<div style="margin-top: 30px;" v-if="is_gift_add">
								<el-form-item>
									<!-- <el-button type="primary" @click="submitForm('dynamicValidateForm')">验证填写信息</el-button> -->
									<el-button @click="addDomain">新增报名人员</el-button>
									<!-- <el-button @click="resetForm('dynamicValidateForm')">重置报名人员信息</el-button> -->
								</el-form-item>
								<el-alert
								    title="报名信息填写验证通过"
								    type="success"
									v-if="alert_show1">
								  </el-alert>
							</div>
							<div style=" width: 100%; margin-top: 30px; font-size: 15px; color: #515a6e; padding-left: 160px; box-sizing: border-box;" v-if="!is_gift_add">							  
								  <i class="el-icon-warning-outline" style="margin-right: 5px;"></i>如需添加更多报名人员请联系工作人员
							</div>
							
						</el-form>
						
						<div v-if="detailData && (detailData.student_price || (detailData.package_items && detailData.package_items.length>0 && detailData.package_items[0].student_price))" style="display: flex; flex-direction: column; width: 640px;font-size: 14px; margin-top: 12px; line-height: 1.5;text-align: justify;">
							暂不支持同时添加多种身份的报名人员，如有需要请分别使用不同账号提交报名信息或联系工作人员<br>
							温馨提示：学生身份的报名人员，参会时请务必携带学生证，会务组会在报到时核验报名信息
						</div>
					</div>
					
					
					<div v-if="total_fee > 0" style="display: flex;  margin-top: 58px;">
						<el-checkbox v-model="checked" @change="checkedChangeEvent">我要发票<span style=" font-size: 14px;">（如果您不需要发票请取消勾选）</span></el-checkbox>
					</div>
					
					<div v-if="checked">
						<div style="font-size: 18px;color: #333;font-weight: 600; padding: 40px 0 10px 0;">
							发票信息
						</div>
						
						<div style="display: flex; flex-direction: column; width: 640px;">
							<div style="font-size: 14px; margin: 12px 0 30px 0; line-height: 1.5; text-align: justify;">
								我社统一开具电子普票，会后发送至您预留的邮箱。如需专票，请联系工作人员。<br>
								为避免后续开具的发票无法用于报销，填写发票信息前务必找贵校/贵司财务专员确认最新开票信息。
							</div>
						
							<el-form :model="dynamicValidateForm2" ref="dynamicValidateForm2" label-width="240px">
								<div v-for="(domain, index) in dynamicValidateForm2.domains" :key="domain.key">
									
									<el-form-item label="开票金额">
										<div style="display:flex;  width: 100%; line-height: 1; align-items: center; ">
											<div style="display: flex; flex-direction: column;justify-content: center;  align-items: center;font-size: 18px;font-weight: 600;">
												{{domain.total_fee}}
												<span style="font-size: 12px;margin-top: 5px;">（每张开票金额）</span>
											</div>
											
											<div style="display: flex; justify-content: center;  align-items: center;font-size: 18px;font-weight: 600;">
												×
											</div>
											
											<div style="display: flex; flex-direction: column; justify-content: center;  align-items: center;font-size: 18px;font-weight: 600;">
												{{domain.invoice_count}}
												<span style="font-size: 12px;margin-top: 5px;">（开票张数）</span>
											</div>
											
											<div style="display: flex; justify-content: center;  align-items: center;font-size: 18px;font-weight: 600;">
												=
											</div>
											
											<div style="display: flex;flex-direction: column; justify-content: center;  align-items: center;font-size: 18px;font-weight: 600;">
												{{total_fee}}
												<span style="font-size: 12px; margin-top: 5px;">（开票总金额）</span>
											</div>
										</div>
										
									</el-form-item>
									
									<el-form-item v-if="gift_count>1" :prop="'domains.' + index + '.invoice_make_type'" label="开具方式" :rules="[{ required: true, message: '请选择发票类目', trigger: 'change' }]">
										<el-radio-group v-model="domain.invoice_make_type" @input="bindInvoiceData">
											  <el-radio label="统一开具" checked></el-radio>
											  <el-radio label="单独开具"></el-radio>
										</el-radio-group>
									</el-form-item>
									
							
									<el-form-item :prop="'domains.' + index + '.invoice_type'" label="发票类型"
										:rules="[{ required: true, message: '请选择发票类型', trigger: 'change' }]">
										<el-radio-group v-model="domain.invoice_type" @input="changeInvoiceType($event,index)">
											<el-radio label="2">数电普票</el-radio>
											<el-radio label="1">数电专票</el-radio>
										</el-radio-group>
									</el-form-item>
									
									<el-form-item v-if="gift_count>1 && domain.invoice_make_type == '统一开具'" :prop="'domains.' + index + '.invoice_unit'" label="计量单位"
										:rules="[{ required: true, message: '请选择计量单位', trigger: 'change' }]">
										<el-radio-group v-model="domain.invoice_unit">
											<el-radio label="人">人（单位 人，数量 {{gift_count}}）</el-radio>
											<el-radio label="次">次（单位 次，数量 1）</el-radio>
										</el-radio-group>
									</el-form-item>
									
									
									<el-form-item :prop="'domains.' + index + '.title'"  label="发票抬头" :rules="[{ required: true, message: '请输入发票抬头', trigger: ['blur', 'change'] }]">
										<!-- <el-input v-model="domain.title" placeholder="请输入发票抬头"></el-input> -->
										<el-autocomplete
										      class="inline-input"
										      v-model="domain.title"
										      :fetch-suggestions="querySearch"
										      placeholder="请输入发票抬头"
											  :trigger-on-focus="false"
										      @select="handleSelect"
											  style="width: 380px;"
										    ></el-autocomplete>
											
									</el-form-item>
									<el-form-item :prop="'domains.' + index + '.tax_id'" label="发票税号" :rules="[{ required: true, message: '请输入发票税号', trigger: ['blur', 'change'] },{ min: 15, max:20,message: '请输入正确的发票税号', trigger: ['blur', 'change'] }]">
										<el-input v-model="domain.tax_id" placeholder="请输入发票税号(三证合一后税号为18位)"></el-input>
									</el-form-item>
									
									
									<el-collapse v-model="domain.active_names" accordion>
									  <el-collapse-item name="1">
											<template slot="title">
											   地址/电话/开户行/账号(非必填，点击可展开填写)  <i class="header-icon el-icon-info"></i> 
											</template>
											
											<div>
												<el-form-item :prop="'domains.' + index + '.registered_address'" label="地址(非必填)">
													<el-input v-model="domain.registered_address" placeholder="请输入开票信息中的单位地址"></el-input>
												</el-form-item>
												<el-form-item :prop="'domains.' + index + '.registered_contact'" label="电话(非必填)">
													<el-input v-model="domain.registered_contact" placeholder="请输入开票信息中的单位电话"></el-input>
												</el-form-item>								
												<el-form-item :prop="'domains.' + index + '.bank'" label="开户行(非必填)">
													<el-input v-model="domain.bank" placeholder="请输入开票信息中的开户行名称"></el-input>
												</el-form-item>
												<el-form-item :prop="'domains.' + index + '.bank_account'" label="账号(非必填)">
													<el-input v-model="domain.bank_account" placeholder="请输入开票信息中的银行账号"></el-input>
												</el-form-item>
											</div>
									  </el-collapse-item>
									</el-collapse>
									
									
									<!-- <el-form-item :prop="'domains.' + index + '.category'" label="发票类目" :rules="[{ required: true, message: '请选择发票类目', trigger: 'change' }]">
										<div style="line-height: 1.4;margin: 12px 0;color: #999"
											v-if="detailData.case_type != 2 && id!='t_c14ccdb632ea4a9c98f072cf539221a3'">
											开具的发票中会议费显示为『*会展服务*会议费』，培训费显示为『*非学历教育服务*{{detailData.title}}培训费』，请根据可开类目选择
										</div>
										<el-radio-group v-model="domain.category">
										      <el-radio label="会议费" v-if="detailData.case_type != 2"></el-radio>
											  <el-radio label="培训费"  v-if="id!='t_0a30bf778763435dabdbb2ca67569fb7' && id!='t_c14ccdb632ea4a9c98f072cf539221a3'"></el-radio>
											  <!--  
											  <el-radio label="信息服务费"></el-radio>
										      <el-radio label="技术服务费"></el-radio>
											  <el-radio label="其他"></el-radio> 
											  -->
										<!-- </el-radio-group>
									</el-form-item> -->
									
									
									<el-form-item :prop="'domains.' + index + '.category'" label="发票类目"
										:rules="[{ required: true, message: '请选择发票类目', trigger: 'change' }]">
										<div style="line-height: 1.4;margin: 12px 0;color: #999"
											v-if="detailData.case_type != 2">
											开具的发票中<span v-if="detailData.invoice_category_items.includes('会务费')">会务费显示为『*生产生活服务*会务费』，</span><span v-if="detailData.invoice_category_items.includes('会议费')">会议费显示为『*生产生活服务*会议费』，</span><span v-if="detailData.invoice_category_items.includes('培训费')">培训费显示为『*生产生活服务*{{detailData.title}}培训费』，</span>请根据可开类目选择。为防止类目额度超标或当月类目额度已使用完无法报销等情况，请老师最好咨询贵校/贵司财务专员后再进行选择。
										</div>
										<el-radio-group v-model="domain.category">
											<el-radio :label="invoice_category_item" v-for="invoice_category_item in detailData.invoice_category_items"></el-radio>
										</el-radio-group>
									</el-form-item>
									
									
									<!-- 
									<el-form-item v-if="domain.category == '其他'" :prop="'domains.' + index + '.category_other'" label="其他发票类目" :rules="[{ required: true, message: '请输入发票类目', trigger: 'change' }]">
										<el-input v-model="domain.category_other" placeholder="请输入其他发票类目"></el-input>
									</el-form-item>
									-->
									
									<el-form-item :prop="'domains.' + index + '.email'" label="发票接收邮箱" :rules="[{ required: true, message: '请输入邮箱地址', trigger: ['blur', 'change'] },{ type: 'email', message: '请输入正确的邮箱地址', trigger: ['blur', 'change'] }]">
										<el-input v-model="domain.email" placeholder="请输入邮箱地址" ></el-input>
									</el-form-item>
									<el-form-item :prop="'domains.' + index + '.mobile'" label="发票接收人手机" :rules="[{ required: true, message: '请输入手机号码', trigger: ['blur', 'change'] },{ pattern: /^[1][3-9][0-9]{9}$/, message: '请输入正确的手机号码', trigger: ['blur', 'change'] }]">
										<el-input v-model="domain.mobile" placeholder="请输入手机号码"></el-input>
									</el-form-item>
									
								
								</div>
								
								<div style="margin-top: 30px;">
									<el-alert
									    title="开票信息填写验证通过"
									    type="success"
										v-if="alert_show2">
									</el-alert>
								</div>
							</el-form>
						</div>
						
						
					</div>
					
				</div>
				
				<div @click="infoConfirm" style="display: flex; justify-content: center; align-items: center; margin-top: 40px;">
					<div style="font-size: 17px; background: linear-gradient(to right,#C63E31,#FB9026); color: #fff;  border-radius: 34px; width:150px ; height:34px; display: flex; justify-content: center; align-items: center; cursor: pointer;">提交报名信息</div>
				</div>
				
			</div>
		</div>
		
		<div class="sign_up_container" style="width: 1200px; display: flex; flex-direction: column;" v-if="page_index == 2">
			<div style="display: inline-flex; flex-direction: column; width: 1200px;  z-index: 3;">
				<div style="display: flex; margin: 70px 0 40px 0;">
					<div style="margin-right: 10px;width: 5px;background: linear-gradient(to bottom,#ff9000,#c93a2e);"></div>
					<div v-if="stateData.result == 1"
						style="display: flex;flex-direction: column; line-height: 1;font-size: 28px; color: #333;">
						报名成功
					</div>
					<div v-if="stateData.result == 0"
						style="display: flex;flex-direction: column; line-height: 1;font-size: 28px; color: #333;">
						提交成功
					</div>
				</div>
			</div>
		
			<div style="display: flex;flex-direction: column; background-color: #fff; box-shadow: 1px 2px 1px #eee; border-radius: 15px; padding: 50px; margin-bottom: 50px; ;line-height: 1;">
		
				<div style="display: flex;flex-direction: column;justify-content: center; align-items: center; padding: 48px 0 40px 0; box-sizing: border-box; border-bottom: 1px solid #eee;">
					<img src="../../assets/images/icon_success.png" style="width: 120px; height: auto;" />
					<div v-if="stateData.result == 0" style=" font-size: 24px; margin-top: 30px; color: #333;">
						报名信息已提交成功
					</div>
					<div v-if="stateData.result == 1" style=" font-size: 24px; margin-top: 30px; color: #333;">
						报名成功
					</div>
					<div style="width: 640px;display: flex; flex-direction:column;margin-top: 40px; font-size: 17px; line-height: 1.75;color: #333;">
						<div>报名信息如下：</div>
						<div>项目名称：{{detailData.title}}</div>
						<div v-if="detailData.case_type!=4">
							<div>举办日期：{{detailData.arrival_at}} 至 {{detailData.stop_at}}</div>
							<div>举办地点：{{stateData.place}}</div>
						</div>
						<div>报名人数：{{stateData.applyer_count}} 人</div>
						<div>人员名单：{{stateData.applyer}}</div>
						<div v-if="orderData.total_fee == 0 && detailData.case_type!=4">报名费用：免费</div>
						<div v-if="orderData.total_fee > 0">
							<div>报名费用：{{orderData.total_fee}} 元</div>
							<div v-if="stateData.result == 1">缴费状态：已缴费</div>
							<div v-if="stateData.result == 0">缴费状态：未缴费</div>
							<div style="display: flex; justify-content: space-between;" v-if="detailData.is_open_pay == 1 && stateData.pay_method == 0">
								<div>缴费方式确认：未确认</div>
								<div style="display: inline-flex; color:#ca3f1e; border-bottom: 1px solid #ca3f1e; cursor: pointer;" @click="toPay">确认缴费方式</div>
							</div>
							<div style="display: flex; flex-direction: column;" v-if="stateData.pay_method !=0">
								<div style="display: flex; justify-content: space-between;" v-if="stateData.result == 0">
									<div style="display: inline-flex;" v-if="stateData.pay_method == 1">缴费方式确认：在线支付</div>
									<div style="display: inline-flex;" v-if="stateData.pay_method == 2">缴费方式确认：对公转账</div>
									<div style="display: inline-flex;" v-if="stateData.pay_method == 3">缴费方式确认：现场缴费</div>
									<div style="display: inline-flex;" v-if="stateData.pay_method == 4">缴费方式确认：扫码支付</div>
									<div style="display: inline-flex; color:#ca3f1e; border-bottom: 1px solid #ca3f1e; cursor: pointer;" @click="toPay">更换缴费方式</div>
								</div>
								<div style="display: flex; flex-direction: column;" v-if="stateData.result == 1">
									<div style="display: inline-flex;" v-if="stateData.pay_method == 1">缴费方式：在线支付</div>
									<div style="display: inline-flex;" v-if="stateData.pay_method == 2">缴费方式：对公转账</div>
									<div style="display: inline-flex;" v-if="stateData.pay_method == 3">缴费方式：现场缴费</div>
									<div style="display: inline-flex;" v-if="stateData.pay_method == 4">缴费方式：扫码支付</div>
								</div>
							</div>
							
							<div v-if="stateData.result == 0" style="display: flex; flex-direction: column;font-size: 24upx; color: #a0a0a0;margin-top: 24px; line-height: 1.5; text-align: justify;">
								<div v-if="stateData.pay_method == 2">您选择的缴费方式为对公转账，支持公对公转账，也支持个人对公转账</div>
								<div v-if="stateData.pay_method == 3">您选择的缴费方式为现场缴费，会议报到当天现场缴费，现场缴费支持刷卡、支付宝、微信支付。</div>
								<div v-if="detailData.is_open_pay == 0">本次会议采用预报名形式，{{detailData.is_open_pay_message}}，后续缴费功能会自动开放，缴费方式支持微信在线支付、对公转账、现场缴费。</div>
							</div>
						</div>
						
					</div>
					<div v-if="detailData.is_open_pay == 1 && stateData.result == 0" style=" width: 640px;  margin: 32px 0;">
						<div style=" width: 100%; display: flex;flex-direction: row; justify-content:  space-between;">
							<div @click="toPay" style="font-size: 17px; background: linear-gradient(to right,#C63E31,#FB9026); color: #fff;  border-radius: 34px; width:240px; height:34px; display: flex; justify-content: center; align-items: center; cursor: pointer;">
								<div v-if="stateData.pay_method !=2 && stateData.pay_method !=4">立即缴费</div>
								<div v-if="stateData.pay_method == 2">查看转账信息</div>
								<div v-if="stateData.pay_method == 4">查看扫码信息</div>
							</div>
							
							<div @click="toDetail" style="font-size: 17px; background: linear-gradient(to right,#C63E31,#FB9026); color: #fff;  border-radius: 34px; width:240px; height:34px; display: flex; justify-content: center; align-items: center; cursor: pointer;">
								稍后缴费
							</div>
						</div>
						<div v-if="!orderData.media_list || (orderData.media_list && orderData.media_list.length == 0)" style="width: 100%;display: flex;flex-direction: column; margin-top: 40px; ">
							<div style="font-size: 17px;color: #333;line-height: 1.75;">如果您已经通过对公转账或扫码支付的方式完成缴费，请上传缴费凭证，以便工作人员及时确认缴费状态。</div>
							<div class="pic2_box">
								<el-upload
										v-if="!imgList || (imgList && imgList.length < 1)"
										:file-list="imgList"
										accept=".jpg,.jpeg,.png,.bmp"
										action="#"
										drag
										multiple
										:auto-upload="false"
										:show-file-list="false"
										:limit="3"
										:on-exceed="handleImgExceed"
										:on-change="handleImgChange"
									>
										<i class="el-icon-plus" style="margin-right: 8px;"></i>
										请选择或拖拽上传图片，限制每个5M以内
								  </el-upload>
							  
								  <div class="pic" v-if="imgList" v-for="(item,index) in imgList">
									<div class="image_box">
										<el-image 
											class="image"
											:src="getImgUrl(item.raw)" 
											:preview-src-list="[getImgUrl(item.raw)]">
										  </el-image>
									</div>
									<div class="info">
										<div class="title">{{item.name}}</div>
										<div class="exts" @click="delImgClick(item)">
											<div class="media_size">{{getFileSize(item.size)}}</div>
											<i class="el-icon-delete delicon"></i>
										</div>
									</div>
								  </div>
							</div>
							<div style=" width: 100%; display: flex;flex-direction: row; margin-top: 16px;">
								<div @click="uploadImgConfirmClick" style="font-size: 17px; background: linear-gradient(to right,#C63E31,#FB9026); color: #fff;  border-radius: 34px; width:240px; height:34px; display: flex; justify-content: center; align-items: center; cursor: pointer;">
									确认上传
								</div>
							</div>
						</div>
					</div>
					
					<div v-if="orderData.media_list && orderData.media_list.length>0" style="width: 640px; display: flex; flex-direction:  column;">
						<div style="font-size: 17px;color: #333;line-height: 1.75;">
							<span v-if="stateData.result == 0">缴费凭证已上传，工作人员会尽快确认缴费状态。</span>
							<span v-if="stateData.result == 1">缴费凭证（截图）：</span>
						</div>
						<div class="pic2_box">
							  <div class="pic" v-for="(item,index) in orderData.media_list">
								<div class="image_box">
									<el-image 
										class="image"
										:src="item.img_url_compressed" 
										:preview-src-list="loadPreviewSrcList()">
									  </el-image>
								</div>
								<div class="info">
									<div class="title">{{item.title}}</div>
									<div class="exts">
										<div class="media_size">{{item.media_size}}</div>
									</div>
								</div>
							  </div>
						</div>
					</div>
					
					<div v-if="detailData.is_open_study == 1 && stateData.result == 1" style=" width: 640px; display: flex;flex-direction: column; margin-top: 60px;">
						<div @click="toStudyClick" style="font-size: 17px; background: linear-gradient(to right,#C63E31,#FB9026); color: #fff;  border-radius: 34px; width:100%; height:34px; display: flex; justify-content: center; align-items: center; cursor: pointer;">
							开启特训营的学习
						</div>
					</div>
					
					
					<div v-if="detailData.kf_qrcode_img_url" style=" width: 640px; font-size: 17px;color: #999; line-height: 1.3; margin-top: 50px; display: flex; flex-direction: column; ;justify-content: center;align-items: center; ">
						<div>报名后，请各位老师扫描下方二维码添加客服微信号，添加好友时请备注：会议/项目名称+姓名+学校+老师/学生/公司人员，邀请您进本次会议/项目专属群，我们将在群内发布本次会议/项目更多信息。</div>
						<div style="margin-top: 30px;" v-if="detailData">
							<img v-if="detailData.kf_qrcode_img_url" :src="detailData.kf_qrcode_img_url" style="width: 320px;" />
							<img v-if="!detailData.kf_qrcode_img_url" src="../../assets/images/qrcode_kf.jpg" style="width: 320px;" />
						</div>
					</div>
					
					<div v-if="!detailData.kf_qrcode_img_url" style=" width: 640px; font-size: 17px;color: #999; line-height: 1.3; margin-top: 50px; display: flex; flex-direction: column;  ">
						<div>会务联系人：</div>
						<div style="margin-top: 5px; line-height: 1.5;" >
							<div v-if="detailData.contacts.split(';').length>0"
								v-for="(item,index) in detailData.contacts.split(';')" :key="index">{{item}}</div>
						</div>
					</div>
		
				</div>
				<div style="display: flex; flex-direction: column; padding:40px 0; box-sizing: border-box;">
					<div style="display: flex;flex-direction: column;">
						<div style="font-size: 18px; color: #666;line-height: 1.4; margin-top: 40px;">
							推荐您关注我们的微信公众号，<br>
							获取最新会议信息，结识更多优秀教师好友。<br>
							
						</div>
						<div style="display: flex;  justify-content: space-between; margin-top: 40px;">
							<div style="display: flex;align-items: flex-end; ">
								<div style="width: 132px;height: 132px;border: 1px solid #eee; background-color: #eee; margin-right: 20px;">
									<img src="../../assets/images/qrcode_for_cmptt.jpg" style="width: 130px;" />
								</div>
								<div style="font-size: 18px;">
									<i class="el-icon-caret-left"></i>
									扫码关注公众号
								</div>
							</div>
							<div style="display: flex;align-items: flex-end;">
								<img src="../../assets/images/logo.png" style="width: 180px; height: auto;" />
							</div>
						</div>
					</div>
				</div>
			</div>
		</div>
		
		<div class="sign_up_container" style="width: 1200px; display: flex; flex-direction: column;" v-if="page_index == 3">
			<!-- 支付 -->
			<div style="display: inline-flex; flex-direction: column; width: 1200px;  z-index: 3;">
				<div style="display: flex; margin: 70px 0 40px 0;">
					<div style="margin-right: 10px;width: 5px;background: linear-gradient(to bottom,#ff9000,#c93a2e);">
					</div>
					<div style="display: flex;flex-direction: column; line-height: 1;font-size: 28px; color: #333;">
						缴费
					</div>
				</div>
			</div>
			
			<div style="display: flex;flex-direction: column; background-color: #fff; box-shadow: 1px 2px 1px #eee; border-radius: 15px; padding: 35px; margin-bottom: 60px;line-height: 1;">
				<div style="font-size: 18px;color: #333; font-weight: 600;">请选择缴费方式</div>
				<div class="pay_tabs">
					
					<div v-if="detailData.is_online_pay == 1" class="pay_tab" :class="{'actived':pay_tab_index == 1}" @click="changePayTab(1)">
						<img src="../../assets/images/icon_weixin.png" style="width: 50px;margin-right: 10px;" />
						微信支付
						<div v-if="pay_tab_index == 1" class="tag">
							<i class="el-icon-check" style="color: #fff;font-size:14px;"></i>
						</div>
					</div>
					
					<div v-if="detailData.is_scan_pay == 1 && detailData.payment_qrcode_img_url" class="pay_tab" :class="{'actived':pay_tab_index == 4}" @click="changePayTab(4)">
						<img src="../../assets/images/icon_qr_scan.png" style="width: 50px; margin-right: 10px;" />
						扫码支付
						<div v-if="pay_tab_index == 4" class="tag">
							<i class="el-icon-check" style="color: #fff;font-size:14px;"></i>
						</div>
					</div>
					<div class="pay_tab" :class="{'actived':pay_tab_index == 2}" @click="changePayTab(2)">
						<img src="../../assets/images/icon_transfer.png" style="width: 50px; margin-right: 10px;" />
						对公转账
						<div v-if="pay_tab_index == 2" class="tag">
							<i class="el-icon-check" style="color: #fff;font-size:14px;"></i>
						</div>
					</div>
					<div v-if="stateData.is_offline_pay == 1" class="pay_tab" :class="{'actived':pay_tab_index == 3}" @click="changePayTab(3)">
						<img src="../../assets/images/icon_face_to_face.png" style="width: 50px; margin-right: 10px;" />
						现场缴费
						<div v-if="pay_tab_index == 3" class="tag">
							<i class="el-icon-check" style="color: #fff;font-size:14px;"></i>
						</div>
					</div>
				</div>


				<div v-if="pay_tab_index == 1" style="display: flex; flex-direction: column; justify-content: center; align-items: center; margin-top: 65px;">
					<div style="border: 1px solid #eee; background-color: #eee; width: 232px; height: 232px;">
						<div ref="qrcode" style="width: 230px; height: 230px;"></div>
					</div>
					<div style="font-size: 24px; margin-top: 40px; " v-if="orderData && orderData.total_fee">
						总金额：¥{{orderData.total_fee}}
					</div>
					<div style="font-size: 22px;color: #999; margin-top:15px;">
						请使用微信扫码支付
					</div>
				</div>
				
				
				<div v-if="pay_tab_index == 4" style="display: flex; flex-direction: column; justify-content: center; align-items: center; margin-top: 65px;">
					<div style="border: 1px solid #eee; background-color: #eee; width: 300px;  display: inline-flex;">
						<img :src="detailData.payment_qrcode_img_url" style="width: 300px; height: auto;"/>
					</div>
					<div style="font-size: 24px; margin-top: 40px;text-align: center;" v-if="orderData && orderData.total_fee">
						总金额：¥{{orderData.total_fee}}
					</div>
					<div style="font-size: 22px;color: #999; margin-top:15px;">
						请使用微信或支付宝扫码支付
					</div>
				</div>
				
				
				<div v-if="pay_tab_index == 2" style="display: flex; flex-direction: column; justify-content: center; align-items: center; margin-top: 100px; line-height: 1;">
					<div style="font-size: 18px; line-height: 2;" v-if="orderData">
						<span style="font-weight: 600;" v-if="orderData.total_fee">打款金额：</span>¥ {{orderData.total_fee}}<br>
						<span style="font-weight: 600;">收款账号：</span>{{orderData.transfer_info.bank_account_number}}<br>
						<span style="font-weight: 600;">收款公司名称：</span>{{orderData.transfer_info.bank_account_name}}<br>
						<span style="font-weight: 600;">开户行：</span>{{orderData.transfer_info.bank_name}}<br>
						<span style="font-weight: 600;">备注信息：</span><span v-if="orderData.transfer_info.transfer_text">{{orderData.transfer_info.transfer_text}}</span><span v-if="!orderData.transfer_info.transfer_text && orderData.remark">{{orderData.remark.replace('机工特训营','机工教育会议')}}</span><br>
						<span style="color: #999;">温馨提示：对公转账支持公对公转账，也支持个人对公转账</span>
					</div>
					<div @click="copyText" style="width: 160px; height: 36px; border-radius: 10px;  background-color: #FCA459;color: #fff; font-size: 18px; display: flex;justify-content: center; align-items: center; margin-top: 35px; margin-bottom: 40px; cursor: pointer;">
						一键复制转账信息
					</div>
				</div>
				<div v-if="pay_tab_index == 3 && detailData" style="display: flex; flex-direction: column; justify-content: center; align-items: center; margin-top: 100px; line-height: 1;">
					<div style="font-size: 24px; line-height: 2; width: 500px;">
						温馨提示：<br>您选择的缴费方式为现场缴费，会议报到当天现场缴费，现场缴费支持刷卡、支付宝、微信支付。
					</div>
				</div>
				<div v-if="pay_tab_index == 1 && detailData.payment_type == 1" @click="finishConfirm" style="display: flex; justify-content: center; align-items: center; margin-top: 40px;">
					<div style="font-size: 17px; background: linear-gradient(to right,#C63E31,#FB9026); color: #fff;  border-radius: 34px; width:150px ; height:34px; display: flex; justify-content: center; align-items: center; cursor: pointer;">已完成支付</div>
				</div>

				
				<div v-if="pay_tab_index != 1 || (pay_tab_index == 1 && detailData.payment_type == 2)" @click="updateOrderInfo(pay_tab_index)" style="display: flex; justify-content: center; align-items: center; margin-top: 40px;">
					<div style="font-size: 17px; background: linear-gradient(to right,#C63E31,#FB9026); color: #fff;  border-radius: 34px; width:150px ; height:34px; display: flex; justify-content: center; align-items: center; cursor: pointer;">确认缴费方式</div>
				</div>
				
				<div v-if="detailData.kf_qrcode_img_url" style="font-size: 17px; margin-top: 50px;color: #999; display: flex; flex-direction: column; ;justify-content: center;align-items: center; ">
					<div style="width: 500px; text-align: justify; line-height: 1.5;">报名后，请各位老师添加下方客服微信号，添加好友时请备注：会议名称+姓名+学校+老师/学生/其他，邀请您进本次会议专属群，我们将在群内发布本次会议更多学习信息。</div>
					<div style="margin-top: 30px;">
						<img v-if="!detailData.kf_qrcode_img_url" src="../../assets/images/qrcode_kf.jpg" style="width: 280px;" />
						<img v-if="detailData.kf_qrcode_img_url" :src="detailData.kf_qrcode_img_url" style="width: 280px;" />
					</div>
				</div>
				<div v-if="!detailData.kf_qrcode_img_url" style=" width: 640px; font-size: 17px;color: #999; line-height: 1.3; margin-top: 50px; display: flex; flex-direction: column;  ">
					<div>会务联系人：</div>
					<div style="margin-top: 5px; line-height: 1.5;" >
						<div v-if="detailData.contacts.split(';').length>0"
							v-for="(item,index) in detailData.contacts.split(';')" :key="index">{{item}}</div>
					</div>
				</div>
			</div>
		</div>
		
	
	</div>
</template>

<script>
	import QRCode from "qrcodejs2";
	import apiUrl from "../../js/apiUrl.js";
	import comm from "../../js/comm.js";
	let pca = require("../../js/pca-code.json");
	

	export default {
		data() {
			return {
				dynamicValidateForm: {
					domains: [{
						package_items: '',
						package_items_title: '',
						package_items_disabled: false,
						is_show_more: true,
						name: '',
						mobile: '',
						sex: '',
						job_type: '',
						school: '',
						college: '',
						title: '',
						duty: '',
						teaching_length: '',
						company: '',
						education: '',
						diet_type: '',
						is_dine: '',
						check_in_date: '',
						check_in_date_other: '',
						check_in_plate_number: '',
						stay_type: '',
						hotel: '',
						room_type_before: '',
						room_type: '',
						room_type_other: '',
						room_share_with: '',
						stay_days_arr: '',
						stay_days: '',
						is_visit: '', 
						visit_plate_number: '',
						id_card: '',
						is_cert: '',
						is_cert_disabled: false,
						pca: '',
						province: '',
						city: '',
						area: '',
						address: '',
						email: '',
						course: '',
						major: '',
						department: '',
						hotel_check_in: '',
						hotel_check_out: '',
						is_member: '',
						wechat_id: '',
						is_report: '',
						report_title: '',
						is_speak: '',
						speak_title: '',
						interested: '',
						interested_arr: '',
						dine_items: '',
						dine_items_arr: [],
						topic: '',
						topic_other: '',
						target: '',
						is_recorded: '',
						img_list: [],
						file_list: [],
						is_join_competition: '',
						birth: '',
						competition_group: '',
						competition_course: '',
						competition_course_type: '',
						competition_course_type_other: '',
						competition_teaching_clip_1: '',
						competition_teaching_clip_2: '',
						competition_teaching_portfolio: '',
						report_duration: '',
						report_date: '',
						report_order_by: '',
						key: Date.now()		
					}]
				},
				dynamicValidateForm2: {
					domains: [{
						invoice_make_type: '统一开具',
						invoice_unit: '人',
						invoice_count: '',
						title: '',
						tax_id: '',
						invoice_type: '2',
						category: '',
						category_other: '',
						active_names: '',
						bank: '',
						bank_account: '',
						registered_address: '',
						registered_contact: '',
						rules_bank: {},
						rules_bank_account: {},
						rules_registered_address: {},
						rules_registered_contact: {},
						email: '',
						mobile: '',
						gift_buy_count:'',
						price:'',
						total_fee: '',
						key: Date.now()
					}]
				},
				checked: true, //是否开具发票
				page_index : 1,
				pay_tab_index: 1,
				id: null,
				detailData: null,
				gift_count: 1,
				is_gift_add: true,
				total_fee:0,
				price:0,
				alert_show1:false,
				alert_show2:false,
				search: {
					id: null,
					case_type: 2,
					gift_buy_count: 1,
					product_type: 27,
					is_invoice: 1,
				},
				/*
				orderData: {
					total_fee:'1280',
					out_trade_no:'17110695997V5M5W',
					remark:'',
					qrcode_url:'',
				},*/
				orderData:null,
				stateData: null,
				qrcode: null,
				isLogin:true,
				backtop_id:Date.now().toString(10),
				options: pca,
				invoice_title_list: null,
				showAlert: false,
				imgList : [],
				defaultReportDate:'',
				defaultStartDate2:'',
				defaultRangeDate:'',
				defaultStartDate:'',
				defaultEndDate:'',
				minDate:'',
				pickerOptions: {
				  disabledDate(time) {
					return time.getTime() < Date.now();
				  }
				}
			};
		},
		created() {
			this.isLogin = localStorage.getItem("userLogInInfo") ? true : false;
			if(!this.isLogin){
				//window.top.location.href = "/login";
				this.$router.push({ path: '/login' });
				return;
			}
		   var option = {
		   	id: this.$route.query.id || "",
		   };
		   if (option.id) {
			 this.id = option.id;
			 this.search.id = this.id;
		   	 this.getDetail();
			 this.getInvoiceTitleList();
		   }
		},
		components: {
			qrcode: QRCode,
		},
		methods: {
			dineCheckboxGroupChange(e,index){
				this.dynamicValidateForm.domains[index].dine_items = this.dynamicValidateForm.domains[index].dine_items_arr.join(";");
				console.log(JSON.stringify(JSON.stringify(this.dynamicValidateForm.domains)))
			},
			isVisitChangeEvent(e,index){
				if(e == '是（自行前往）'){
					var check_in_plate_number = this.dynamicValidateForm.domains[index].check_in_plate_number;
					if(check_in_plate_number){
						this.dynamicValidateForm.domains[index].visit_plate_number = check_in_plate_number;
						console.log(this.dynamicValidateForm.domains[index].visit_plate_number);
					}
				}else{
					this.dynamicValidateForm.domains[index].visit_plate_number ='';
				}
			},
			changeInvoiceType(e,index){
				this.$refs.dynamicValidateForm2.clearValidate();
				if(e == 1){
					this.dynamicValidateForm2.domains[index].active_names = '1';
					this.dynamicValidateForm2.domains[index].rules_bank = [{ required: true, message: '请输入开票信息中的开户行名称', trigger: ['blur', 'change'] }];
					this.dynamicValidateForm2.domains[index].rules_bank_account = [{ required: true, message: '请输入开票信息中的银行账号', trigger: ['blur', 'change'] }];;
					this.dynamicValidateForm2.domains[index].rules_registered_address = [{ required: true, message: '请输入开票信息中的单位地址', trigger: ['blur', 'change'] }];;
					this.dynamicValidateForm2.domains[index].rules_registered_contact = [{ required: true, message: '请输入开票信息中的单位电话', trigger: ['blur', 'change'] }];;
				}else{
					this.dynamicValidateForm2.domains[index].active_names = '';
					this.dynamicValidateForm2.domains[index].rules_bank = [];
					this.dynamicValidateForm2.domains[index].rules_bank_account = [];
					this.dynamicValidateForm2.domains[index].rules_registered_address = [];
					this.dynamicValidateForm2.domains[index].rules_registered_contact = [];
				}
			},
			toDetail(){
				this.GoToDetail(this.detailData.product_type,this.detailData.id);
			},
			toPay(){
				this.page_index = 3;
				
				if(this.stateData.pay_method!=0){
					this.changePayTab(this.stateData.pay_method);
				}else{
					if(this.detailData.is_online_pay==1){
						this.changePayTab(1);
					}else if(this.detailData.is_scan_pay==1){
						this.changePayTab(4);
					}else{
						this.changePayTab(2);
					}
				}
			},
			copyText() {
				var text='';
				
				
				/*
				text +='打款金额：¥ '+this.orderData.total_fee+'\r\n';
				text +='收款账号：0200 0014 0920 0070 931\r\n';
				text +='收款公司名称：机械工业出版社有限公司\r\n';
				text +='开户行：中国工商银行北京百万庄支行\r\n';
				text +='备注信息：'+ this.orderData.remark.replace('机工特训营','机工教育会议') +'\r\n';
				*/
				
				text += '打款金额：¥ ' + this.orderData.total_fee + '\r\n';
				text += '收款账号：'+ this.orderData.transfer_info.bank_account_number +'\r\n';
				text += '收款公司名称：'+this.orderData.transfer_info.bank_account_name +'\r\n';
				text += '开户行：'+this.orderData.transfer_info.bank_name+'\r\n';
				if(this.orderData.transfer_info.transfer_text){
					text += '备注信息：' + this.orderData.transfer_info.transfer_text + '\r\n';
				}else{
					text += '备注信息：' + this.orderData.remark + '\r\n';
				}
				
				
			     this.$copyText(text).then((res)=>{
					  //console.log("内容已复制到剪切板")
					  this.$alert('内容已复制到剪切板', '提示');
				 }).catch((err)=>{
					 //console.log("抱歉，复制失败")
					 this.$alert('抱歉，复制失败', '提示');
				 })
			},
			changePackageItems(e) {
				this.dynamicValidateForm.domains.forEach((item, index) => {
					item.package_items = e;
					item.package_items_title = this.detailData.package_items.filter(i => i.id == e.toString())[0].title;
					if (index != 0) {
						item.package_items_disabled = true;
					}

					if(this.detailData.case_type != 2){
						if(item.package_items_title.indexOf('线上')>-1){
							item.is_show_more =false;
						}else{
							item.is_show_more =true;
						}
					}else{
						item.is_show_more = false;
					}
				})
				
				var job_type = this.dynamicValidateForm.domains[0].job_type;
				var _package_item = this.detailData.package_items.filter(i => i.id == e.toString())[0];
				
				if (job_type == '学生' && _package_item.student_price) {
					this.price = parseFloat(_package_item.student_price);
				} else if((job_type == '其他' || job_type == '企业人员') && _package_item.company_price){
					this.price = parseFloat(_package_item.company_price);
				} else {
					this.price = parseFloat(_package_item.price);
				}
				this.total_fee = this.price * this.gift_count * 1.00;
				this.bindInvoiceData();
				this.isGiftAdd();
			},
			inputEmailBlurEvent(){
				var email = this.dynamicValidateForm2.domains[0].email;
				if (!email) {
					this.dynamicValidateForm2.domains[0].email = this.dynamicValidateForm.domains[0].email;
				}
			},
			inputMobileBlurEvent(){
				var mobile = this.dynamicValidateForm2.domains[0].mobile;
				if(!mobile){
					this.dynamicValidateForm2.domains[0].mobile = this.dynamicValidateForm.domains[0].mobile;
				}
			},
			bindInvoiceData(){
				if (this.total_fee && this.total_fee > 0) {
					this.checked = true;
				} else {
					this.checked = false;
				}
				
				var type = this.dynamicValidateForm2.domains[0].invoice_make_type;
				if(type){
					if(type == "单独开具"){
						this.dynamicValidateForm2.domains[0].invoice_count = this.gift_count;
						this.dynamicValidateForm2.domains[0].total_fee = this.price.toString();
						this.dynamicValidateForm2.domains[0].gift_buy_count = 1;
						this.dynamicValidateForm2.domains[0].price = this.price.toString();
						var invoice_unit = this.dynamicValidateForm2.domains[0].invoice_unit;
						if(invoice_unit!='人'){
							this.dynamicValidateForm2.domains[0].invoice_unit = '人';
						}
					}else{
						this.dynamicValidateForm2.domains[0].invoice_count = 1;
						this.dynamicValidateForm2.domains[0].total_fee = this.total_fee.toString();
						this.dynamicValidateForm2.domains[0].gift_buy_count = this.gift_count;
						this.dynamicValidateForm2.domains[0].price = this.price.toString();
						var invoice_unit = this.dynamicValidateForm2.domains[0].invoice_unit;
						if(invoice_unit!='人' && this.gift_count == 1){
							this.dynamicValidateForm2.domains[0].invoice_unit = '人';
						}
					}
				}
			},
			isGiftAdd() {
				var next_total_fee = this.price * (this.gift_count + 1) * 1.00;
				if (next_total_fee > 80000.00) {
					this.is_gift_add = false;
				} else {
					this.is_gift_add = true;
				}
			},
			scrollTop(){
				this.backtop_id = Date.now().toString();
				this.$nextTick(()=>{
					//window.scrollTop(0,0);
					window.location.hash =this.backtop_id;
				});
			},
			toStudyClick(){
				var url = "/trainingCamp/study";
				var query = { id: this.id };
				let routeUrl = this.$router.resolve({
					path: url,
					query: query,
				});
				window.open(routeUrl.href, "_blank");
			},
			checkedChangeEvent(e) {
				if (!e) {
					this.checked = true;
					this.$confirm('您确认不需要开具发票么，确认后会务组将不再为您开具发票?', '提示', {
						confirmButtonText: '确定',
						cancelButtonText: '取消',
						type: 'warning'
					}).then(() => {
						this.$message({
							type: 'success',
							message: '设置成功!'
						});
						this.checked = false;
					}).catch(() => {
						this.$message({
							type: 'info',
							message: '已取消操作'
						});
					});
				}
			},
			jobTypeChangeEvent(){
				var _package_item = null;
				if (this.detailData.package_items && this.detailData.package_items.length > 0 && this.dynamicValidateForm.domains[0].package_items) {
					var _package_items = this.dynamicValidateForm.domains[0].package_items;
					_package_item = this.detailData.package_items.filter(i => i.id == _package_items.toString())[0];
				}
				
				//有学生价/企业人员价时，身份变更时，定价更新
				if (this.detailData.student_price
				|| this.detailData.company_price 
				|| (_package_item && _package_item.student_price) 
				|| (_package_item && _package_item.company_price)
				) {
					if(!this.dynamicValidateForm.domains[0].job_type){
						var _job_type='';
						this.dynamicValidateForm.domains.forEach((item,index)=>{
							if(item.job_type){
								_job_type = item.job_type;
							}
						})
						this.dynamicValidateForm.domains[0].job_type = _job_type;
					}
					
					this.dynamicValidateForm.domains.forEach((item,index)=>{
						item.job_type = this.dynamicValidateForm.domains[0].job_type;
						if(index!=0){
							item.job_type_disabled = true;
						}
					})
					
					var job_type = this.dynamicValidateForm.domains[0].job_type;
					if(_package_item){
						if (job_type == '学生' && _package_item.student_price) {
							this.price = parseFloat(_package_item.student_price);
						} else if((job_type == '其他' || job_type == '企业人员') && _package_item.company_price){
							this.price = parseFloat(_package_item.company_price);
						} else {
							this.price = parseFloat(_package_item.price);
						}
					}else{
						if (job_type == '学生' && this.detailData.student_price) {						
							this.price = parseFloat(this.detailData.student_price);
						} else if((job_type == '其他' || job_type == '企业人员') && this.detailData.company_price){
							this.price = parseFloat(this.detailData.company_price);
						} else {
							this.price = parseFloat(this.detailData.price);
						}
					}
					this.total_fee = this.price * this.gift_count * 1.00;
					this.bindInvoiceData();
				}
			},
			isCertChangeEvent() {
				if (this.detailData.cert_fee) {
			
					if (!this.dynamicValidateForm.domains[0].is_cert) {
						var _is_cert = '';
						this.dynamicValidateForm.domains.forEach((item, index) => {
							if (item.is_cert) {
								_is_cert = item.is_cert;
							}
						})
						this.dynamicValidateForm.domains[0].is_cert = _is_cert;
					}
			
					this.dynamicValidateForm.domains.forEach((item, index) => {
						item.is_cert = this.dynamicValidateForm.domains[0].is_cert;
						if (index != 0) {
							item.is_cert_disabled = true;
						}
					})
			
			
					if (this.dynamicValidateForm.domains[0].is_cert == '是') {
						this.price = parseFloat(this.detailData.price) + parseFloat(this.detailData.cert_fee);
					} else {
						this.price = parseFloat(this.detailData.price);
					}
					this.total_fee = this.price * this.gift_count * 1.00;
					this.bindInvoiceData();
				}
			},
			addDomain() {
				var _package_items = '';
				var _package_items_title = '';
				var _package_items_disabled = false;
				var _job_type='';
				var _job_type_disabled = false;
				var _school='';
				var _college='';
				var _company='';
				var _is_cert = '';
				var _is_cert_disabled = false;
				var _is_show_more = true;
				var _diet_type='';
				var _dine_items_arr = '';
				
				
				if(this.detailData.job_type_items && this.detailData.job_type_items.length == 1){
					_job_type = this.detailData.job_type_items[0];
				}
				
				if(this.detailData.has_dine_checkbox == 1 && this.detailData.form_dine_items && this.detailData.form_dine_items.length > 0){
					var arr=new Array();
					this.detailData.form_dine_items.forEach((item,index)=>{
						arr.push({
							name: item,
							checked: false,
							disabled: false
						});
					})
					_dine_items_arr = arr;
				}
				
				if(this.detailData.case_type ==2 && _is_show_more){
					_is_show_more = false;
				}
				
				if (this.detailData.package_items && this.detailData.package_items.length > 0 && this.dynamicValidateForm
					.domains[0].package_items) {
					_package_items = this.dynamicValidateForm.domains[0].package_items;
					_package_items_title = this.detailData.package_items.filter(i => i.id == _package_items.toString())[0].title;
					_package_items_disabled = true;
					if(_package_items_title.indexOf('线上')>-1 && _is_show_more){
						_is_show_more = false;
					}
				}
				if((this.detailData.student_price || this.detailData.company_price) && this.dynamicValidateForm.domains[0].job_type){
					_job_type = this.dynamicValidateForm.domains[0].job_type;
					_job_type_disabled = true;
				}
				if(this.dynamicValidateForm.domains[0].school){
					_school = this.dynamicValidateForm.domains[0].school;
				}
				if(this.dynamicValidateForm.domains[0].college){
					_college = this.dynamicValidateForm.domains[0].college;
				}
				if(this.dynamicValidateForm.domains[0].company){
					_company = this.dynamicValidateForm.domains[0].company;
				}
				if (this.dynamicValidateForm.domains[0].is_cert) {
					_is_cert = this.dynamicValidateForm.domains[0].is_cert;
					_is_cert_disabled = true;
				}
				
				if(this.id =='t_096c479feb0c4562906eb7ab18b25892'){
					_diet_type = '';
				}
				
				this.dynamicValidateForm.domains.push({
					package_items: _package_items,
					package_items_title: _package_items_title,
					package_items_disabled: _package_items_disabled,
					is_show_more: _is_show_more,
					name: '',
					mobile: '',
					sex: '',
					job_type: _job_type,
					job_type_disabled: _job_type_disabled,
					school: _school,
					college: _college,
					title: '',
					duty: '',
					teaching_length: '',
					company: _company,
					education: '',
					diet_type: _diet_type,
					is_dine: '',
					check_in_date: '',
					check_in_date_other: '',
					check_in_plate_number: '',
					stay_type: '',
					hotel: '',
					room_type_before: '',
					room_type: '',
					room_type_other: '',
					room_share_with: '',
					stay_days_arr: '',
					stay_days: '',
					is_visit: '',
					visit_plate_number: '',
					id_card: '',
					is_cert: _is_cert,
					is_cert_disabled: _is_cert_disabled,
					pca: '',
					province: '',
					city: '',
					area: '',
					address: '',
					email: '',
					course: '',
					major: '',
					department: '',
					hotel_check_in: '',
					hotel_check_out: '',
					is_member: '',
					wechat_id: '',
					is_report: '',
					report_title: '',
					is_speak: '',
					speak_title: '',
					interested: '',
					interested_arr: '',
					dine_items: '',
					dine_items_arr: [],
					topic: '',
					topic_other: '',
					target: '',
					is_recorded: '',
					img_list: [],
					file_list: [],
					is_join_competition: '',
					birth: '',
					competition_group: '',
					competition_course: '',
					competition_course_type: '',
					competition_course_type_other: '',
					competition_teaching_clip_1: '',
					competition_teaching_clip_2: '',
					competition_teaching_portfolio: '',
					report_duration: '',
					report_date: '',
					report_order_by: '',
					key: Date.now()
				});
				this.gift_count++;
				this.total_fee = this.price * this.gift_count * 1.00;
				this.bindInvoiceData();
				this.isGiftAdd();
			},
			removeDomain(item) {
				var index = this.dynamicValidateForm.domains.indexOf(item)
				if (index !== -1) {
					this.dynamicValidateForm.domains.splice(index, 1)
					this.dynamicValidateForm2.domains.splice(index, 1)
					this.gift_count --;
					this.total_fee =this.price*this.gift_count*1.00;
					this.bindInvoiceData();
					this.isGiftAdd();
				}
			},
			infoConfirm(){
				var that = this;
				that.$refs['dynamicValidateForm'].validate((valid) => {
					if (valid) {
						that.dynamicValidateForm.domains.forEach((item,index)=>{
							if(item.pca && item.pca.length == 3){
								item.province = item.pca[0];
								item.city = item.pca[1];
								item.area = item.pca[2];
							}
						});
						
						if(this.checked){
							//包含发票
							that.$refs['dynamicValidateForm2'].validate((_valid) => {
								if (_valid) {
									console.log('可以提交')
									console.log(this.dynamicValidateForm.domains)
									console.log('dynamicValidateForm' + JSON.stringify(that.dynamicValidateForm.domains))
									console.log('dynamicValidateForm2' + JSON.stringify(that.dynamicValidateForm2.domains))
									that.search.id = this.id;
									that.search.gift_buy_count = this.gift_count;
									that.search.user_list_json = JSON.stringify(that.dynamicValidateForm.domains);
									that.search.invoice_list_json = JSON.stringify(that.dynamicValidateForm2.domains);
									that.goToOrder();
								}
							});
						}else{ 
							//不包含发票
							that.search.id = this.id;
							that.search.gift_buy_count = this.gift_count;
							that.search.user_list_json = JSON.stringify(that.dynamicValidateForm.domains);
							that.goToOrder();
						}
					}
				});
			},
			changePayMethod(index){
				var that = this;
				that.page_index = 2;
				that.detailData.tt_out_trade_no = that.orderData.out_trade_no;
				that.changePayTab(index);
				that.scrollTop();
			},
			goToOrder(){
				//console.log(JSON.stringify(this.search))
			
				var that = this;
				this.search.is_invoice = this.checked ? 1:0;
				var url = apiUrl.tt_purchase_confirm;
				this.Ajax(url, this.search, (data) => {
					that.orderData = data;
					that.page_index = 2;
					that.stateData = {
						pay_method: that.orderData.pay_method,
						result: that.orderData.result,
						applyer: that.orderData.applyer,
						applyer_count:that.orderData.applyer_count,
						time:that.orderData.time,
						place:that.orderData.place,
						is_offline_pay:that.orderData.is_offline_pay,
					};
					that.scrollTop();
					console.log(JSON.stringify(data))
				});
				
			},
			submitForm(formName) {
				this.$refs[formName].validate((valid) => {
					if (valid) {
						if(formName == 'dynamicValidateForm'){
							this.alert_show1 = true;
						}else if(formName == 'dynamicValidateForm2'){
							this.alert_show2 = true;
						}
					} else {
						console.log('error submit!!');
						if(formName == 'dynamicValidateForm'){
							this.alert_show1 = false;
						}else if(formName == 'dynamicValidateForm2'){
							this.alert_show2 = false;
						}
						return false;
					}
				});
			},
			resetForm(formName) {
				this.$refs[formName].resetFields();
			},
			changePayTab(index) {
				this.pay_tab_index = index;
				var that = this;
				that.$nextTick(() => {
					if(that.orderData && that.orderData.qrcode_url){
						that.setupQrCode(that.$refs.qrcode, that.orderData.qrcode_url, 230, (code_img) => {
							that.qrcode = code_img;
						});
					}
				});
			},
			updateOrderInfo(index){
				var that = this;
				var url = apiUrl.tt_order_info_update;
				this.Ajax(url, {
					out_trade_no: that.orderData.out_trade_no,
					pay_method: index,
					product_type:27,
				}, (data) => {
					//that.$alert('缴费方式确认完成');
					that.page_index = 2;
					that.checkOrderState();
				});
			},
			finishConfirm(){
				this.page_index=2;
				this.checkOrderState();
			},
			checkOrderState(){
				var that = this;
				var url = apiUrl.tt_order_state_check;
				this.Ajax(url, { 
					out_trade_no: this.orderData.out_trade_no,
					product_type: 27,
				}, (data) => {
					that.stateData = data;
					that.scrollTop();
				});
			},
			getDetail() {
				var that = this;
				var url = apiUrl.tt_conference_detail_get;
				this.Ajax(url, {
					id: that.id,
					is_sign_up: 1,
				}, (data) => {
					that.detailData = data;
					document.title = "报名 - "+ data.title + ' - 机工教育会议';
					
					if(data.arrival_at){
						var date = new Date(data.arrival_at);
						var start_date = new Date(data.start_at);
						var next_date  = new Date(data.stop_at);
						//var next_date  = new Date(data.arrival_at);
						//next_date =new Date(next_date.setDate(next_date.getDate()+2));
						
						that.defaultStartDate = `${date.getFullYear()}-${date.getMonth()+1}-${date.getDate()}`;
						that.defaultEndDate = `${next_date.getFullYear()}-${next_date.getMonth()+1}-${next_date.getDate()}`;
						that.defaultStartDate2 = `${date.getFullYear()}-${date.getMonth()+1}-${date.getDate()} 12:00:00`;
						that.defaultReportDate = `${start_date.getFullYear()}-${start_date.getMonth()+1}-${start_date.getDate()} 09:00:00`;
						
						var arr=new Array();
						arr.push(that.defaultStartDate);
						arr.push(that.defaultEndDate);
						that.defaultRangeDate = arr;
					}
					
					if(that.id =='t_096c479feb0c4562906eb7ab18b25892'){
						that.dynamicValidateForm.domains[0].diet_type = '';
					}
					
					if (that.detailData.is_package != 1) {
						that.price = parseFloat(that.detailData.price);
					} else {
						/*
						var item = that.detailData.package_items[that.detailData.package_items.length-1];
						that.dynamicValidateForm.domains[0].package_items = item.id;
						that.price = parseFloat(item.price);
						*/
					}
					
					
					//身份类型
					if(this.detailData.job_type_items && this.detailData.job_type_items.length == 1){
						that.dynamicValidateForm.domains[0].job_type = this.detailData.job_type_items[0];
					}
					
					//发票类目
					if(this.detailData.invoice_category_items && this.detailData.invoice_category_items.length>0){
						that.dynamicValidateForm2.domains[0].category = this.detailData.invoice_category_items[0];
					}
					
					if(this.detailData.has_dine_checkbox == 1 && this.detailData.form_dine_items && this.detailData.form_dine_items.length > 0){
						var arr=new Array();
						this.detailData.form_dine_items.forEach((item,index)=>{
							arr.push({
								name: item,
								checked: false,
								disabled: false
							});
						})
						that.dynamicValidateForm.domains[0].dine_items_arr = arr;
					}
					
					if(that.detailData.case_type == 2){
						that.dynamicValidateForm.domains[0].is_show_more = false;
					}
					
					if(that.detailData.is_reg == 0){
						that.page_index = 1;
						that.gift_count = 1;
						that.total_fee =that.price*that.gift_count*1.00;						
						that.bindInvoiceData();

					}else if(that.detailData.order_info){
						that.page_index = 2;
						
						that.stateData = {
							pay_method: that.detailData.order_info.pay_method,
							result: that.detailData.order_info.result,
							applyer: that.detailData.order_info.applyer,
							applyer_count:that.detailData.order_info.applyer_count,
							time:that.detailData.order_info.time,
							place:that.detailData.order_info.place,
							is_offline_pay:that.detailData.order_info.is_offline_pay,
						};
						
						that.orderData = {
							total_fee : that.detailData.order_info.total_fee,
							out_trade_no: that.detailData.order_info.out_trade_no,
							product_id: that.detailData.order_info.product_id,
							product_type: that.detailData.order_info.product_type,
							remark: that.detailData.order_info.remark,
							qrcode_url: that.detailData.order_info.qrcode_url,
							media_list: that.detailData.order_info.media_list,
							transfer_info: that.detailData.order_info.transfer_info,
						};
					}
				});
			},
			//QrCode
			setupQrCode(el, url, width, callback) {
				let code_img = new QRCode(el, {
					width: width,
					height: width, // 高度
					text: url, // 二维码内容
					colorDark: '#333333',
					colorLight: '#ffffff',
					correctLevel: QRCode.CorrectLevel.L,
				});
				if (callback) callback(code_img);
			},
			getInvoiceTitleList() {
				var that = this;
				var url = apiUrl.tt_invoice_title_list_get;
				this.Ajax(url, {}, (data) => {
					that.invoice_title_list = data;
				});
			},
			querySearch(queryString, cb) {
				var restaurants = this.invoice_title_list;
				var results = queryString ? restaurants.filter(this.createFilter(queryString)) : restaurants;
				
				// 调用 callback 返回建议列表的数据
				cb(results);
			},
			createFilter(queryString) {
				return (restaurant) => {
				  return (restaurant.value.toLowerCase().indexOf(queryString.toLowerCase()) === 0);
				};
			},
			handleSelect(item) {
				console.log(item);
				if(item){
					this.dynamicValidateForm2.domains[0].tax_id = item.address;	
				}
			},
			/*上传图片付款凭证 开始*/
			handleImgExceed(files, uploadFiles)  {
				this.$message.error("最多上传3个图片");
			},
			handleImgChange(file, fileList) {
				const MAX_SIZE = 1024 * 1024 * 5; // 5MB
				var arr =new Array();
				fileList.forEach((f,index)=>{
					if (f.size > MAX_SIZE) {
						this.$message.error('每个文件大小不能超过5MB!');
					}else{
						arr.push(f);
					}
				})
				this.imgList = arr;
			},
			delImgClick(item) {
				this.imgList = this.imgList.filter(i => i != item);
			},
			uploadImgConfirmClick(){
				var that = this;
				if(this.imgList.length == 0){
					this.$message.error("请上传图片");
					return;
				}
			
				var url = apiUrl.tt_camp_order_media_upload;
				var formData = new FormData();
				this.imgList.forEach((file,index) => {
					formData.append("file"+index, file.raw);
				});
				var token = "";
				var userInfo = JSON.parse(localStorage.getItem("userLogInInfo"));
				if (userInfo && userInfo.token != '') {
					token = userInfo.token;
				}
				formData.append("token", token);
				formData.append("client_type", 10);
				formData.append("out_trade_no", that.orderData.out_trade_no);
				that.Ajax(url, formData, (data) => {
					that.$message.success("上传成功");
					that.orderData.media_list = data;
					that.imgList = [];
				});
				
			},
			loadPreviewSrcList(){
				if(this.orderData.media_list){
					var arr =new Array();
					this.orderData.media_list.forEach((item,index)=>{
						arr.push(item.img_url);
					})
					return arr;
				}else{
					return [];
				}
			},
			getFileSize(bytes){
				if(bytes >= 1048576){
					return (bytes/1048576).toFixed(2)+' MB';
				}else if(bytes >= 1024){
					return (bytes/1024).toFixed(2)+' KB';
				}else {
					return bytes +' bytes';
				}
			},
			getImgUrl(raw){
			   return URL.createObjectURL(raw);
			},
			getFileExt(name){
				var values = name.split('.');
				return '.'+values[values.length-1].toLowerCase();
			},
			/*上传图片付款凭证 结束*/
			
			/*个人上传图片 开始*/
			delImgClick2(index, item) {
				this.dynamicValidateForm.domains[index].img_list = this.dynamicValidateForm.domains[index].img_list.filter(
					i => i != item);
			},
			handleImgExceed2(files, fileList,index){
				this.$message.error("最多上传"+ this.detailData.form_image_limit +"张图片");
			},
			handleImgChange2(file, fileList,index){
				const MAX_SIZE = 1024 * 1024 * 5; // 5MB
				var arr =new Array();
				fileList.forEach((f,index)=>{
					if (f.size > MAX_SIZE) {
						this.$message.error('每张图片大小不能超过5MB!');
					}else{
						arr.push(f);
					}
				})
				
				var that = this;
				var formData = new FormData();
				arr.forEach((f,index) => {
					formData.append("file"+index, f.raw);
				});
				var token = "";
				var userInfo = JSON.parse(localStorage.getItem("userLogInInfo"));
				if (userInfo && userInfo.token != '') {
					token = userInfo.token;
				}
				formData.append("token", token);
				formData.append("client_type", 10);
				var url = apiUrl.tt_media_upload;
				that.Ajax(url, formData, (data) => {
					that.$message.success("上传成功");
					that.dynamicValidateForm.domains[index].img_list = that.dynamicValidateForm.domains[index].img_list.concat(data);
					console.log(JSON.stringify(that.dynamicValidateForm.domains[index].img_list))
				});
			},
			/*个人上传图片 结束*/
			
			/*个人上传文件（非图片） 开始*/
			delFileClick2(index, item) {
				this.dynamicValidateForm.domains[index].file_list = this.dynamicValidateForm.domains[index].file_list.filter(
					i => i != item);
			},
			handleFileExceed2(files, fileList,index){
				this.$message.error("最多上传"+ this.detailData.form_file_limit +"个文件");
			},
			handleFileChange2(file, fileList,index){
				const MAX_SIZE = 1024 * 1024 * 5; // 5MB
				var arr =new Array();
				fileList.forEach((f,index)=>{
					if (f.size > MAX_SIZE) {
						this.$message.error('每个文件大小不能超过5MB!');
					}else{
						arr.push(f);
					}
				})
				
				var that = this;
				var formData = new FormData();
				arr.forEach((f,index) => {
					formData.append("file"+index, f.raw);
				});
				var token = "";
				var userInfo = JSON.parse(localStorage.getItem("userLogInInfo"));
				if (userInfo && userInfo.token != '') {
					token = userInfo.token;
				}
				formData.append("token", token);
				formData.append("client_type", 10);
				var url = apiUrl.tt_media_upload;
				that.Ajax(url, formData, (data) => {
					that.$message.success("上传成功");
					that.dynamicValidateForm.domains[index].file_list = that.dynamicValidateForm.domains[index].file_list.concat(data);
					console.log(JSON.stringify(that.dynamicValidateForm.domains[index].file_list))
				});
			},
			/*个人上传文件（非图片） 结束*/
			
			/*上传文件相关 开始*/
			handleFileExceed(files, uploadFiles)  {
				this.$message.error("最多上传3个文件");
			},
			handleFileChange(file, fileList) {
				const MAX_SIZE = 1024 * 1024 * 5; // 5MB
				var arr =new Array();
				fileList.forEach((f,index)=>{
					if (f.size > MAX_SIZE) {
						this.$message.error('每个文件大小不能超过5MB!');
					}else{
						arr.push(f);
					}
				})
				this.fileList = arr;
			},
			delFileClick(item) {
				this.fileList = this.fileList.filter(i => i != item);
			},
			uploadFileConfirmClick(){
				var that = this;
				if(this.fileList.length == 0){
					this.$message.error("请上传文件");
					return;
				}
			
				var url = apiUrl.tt_camp_order_media_upload;
				var formData = new FormData();
				this.fileList.forEach((file,index) => {
					formData.append("file"+index, file.raw);
				});
				var token = "";
				var userInfo = JSON.parse(localStorage.getItem("userLogInInfo"));
				if (userInfo && userInfo.token != '') {
					token = userInfo.token;
				}
				formData.append("token", token);
				formData.append("client_type", 10);
				formData.append("out_trade_no", that.orderData.out_trade_no);
				that.Ajax(url, formData, (data) => {
					that.$message.success("上传成功");
					that.orderData.file_list = data;
					that.fileList = [];
				});
				
			},	
			/*上传文件相关 结束*/
			stayDaysConfirmEvent(e,_index){
				console.log(JSON.stringify(e))
				var startDate = e[0];
				var endDate = e[1];
				var index = parseInt(_index);
				var item = this.dynamicValidateForm.domains[index];
				var night = this.calculateNights(startDate,endDate);
				if(night == 0){
					this.$message.error("入住时间与离店时间不可以是同一天，请调整");
					e[0] = '';
					e[1] = '';
					item.stay_days_arr = [];
					item.stay_days = '';
					item.hotel_check_in = '';
					item.hotel_check_out = '';
					return;
				}
				var arr=new Array();
				arr.push(startDate);
				arr.push(endDate);
				item.stay_days_arr = arr;
				item.stay_days = startDate + " 至 "+endDate+"（共"+ night+"晚）";
				item.hotel_check_in = startDate;
				item.hotel_check_out = endDate;
			},
			calculateNights(checkInDateStr, checkOutDateStr) {
			    // 将字符串转换为日期对象
			    const checkInDate = new Date(checkInDateStr);
			    const checkOutDate = new Date(checkOutDateStr);
			 
			    // 设置时间为当天的午夜，避免时分秒的干扰
			    checkInDate.setHours(0, 0, 0, 0);
			    checkOutDate.setHours(0, 0, 0, 0);
			 
			    // 计算两个日期之间的毫秒数差异，然后转换为天数
			    const diffTime = Math.abs(checkOutDate - checkInDate);
			    const diffDays = Math.ceil(diffTime / (1000 * 60 * 60 * 24));
			 
			    return diffDays;
			},
			//比较参会者所选报到日是否与通知上的报到日一致
			isSameDay(checkInDateStr, arrivalAtStr) {
				// 将字符串转换为日期对象
				const checkInDate = new Date(checkInDateStr);
				const arrivalAt = new Date(arrivalAtStr);
			
				// 设置时间为当天的午夜，避免时分秒的干扰
				checkInDate.setHours(0, 0, 0, 0);
				arrivalAt.setHours(0, 0, 0, 0);
			
				// 计算两个日期之间的毫秒数差异，然后转换为天数
				const diffTime = Math.abs(checkInDate - arrivalAt);
				if(diffTime == 0){
					return true;
				}else{
					return false;
				}
			},
			
			
		},
	};
</script>

<style>
	/*单选按钮*/
	/* .el-radio__input.is-checked + .el-radio__label {
	  color: #606266 !important;
	}

	.el-radio__input.is-checked .el-radio__inner {
	  background: #606266 !important;
	  border-color: #606266 !important;
	}
	.el-radio__input:hover{
		border-color: #DCDFE6 !important;
	} */
	
	
	
	.report_date .el-date-table__row .available.default:not(.disabled,.current,.start-date,.end-date) span,
	.stay_days .el-date-table__row .available.default:not(.disabled,.current,.start-date,.end-date) span{
		color: red;
	}
	
	.report_date .el-date-table__row .available.current span::after{
		content: '报告';
		display: block;
		margin-top: -3px;
		font-size: 10px;
		color: #409EFF;
		font-weight: 600;
		z-index: 9;
	}
	
	
	
	.stay_days .el-date-table__row .available.current span::after{
		content: '报到';
		display: block;
		margin-top: -3px;
		font-size: 10px;
		color: #409EFF;
		font-weight: 600;
		z-index: 9;
	}
	
	.stay_days .el-date-table__row .available.start-date span::after{
		content: '入住';
		display: block;
		margin-top: -3px;
		font-size: 10px;
		font-weight: 600;
		color: #409EFF;
		z-index: 9;
	}
	.el-date-editor .el-range-separator{
		 width: 30px !important;
	}
	.stay_days .el-date-table__row .available.end-date span::after{
		content: '离店';
		display: block;
		margin-top: -3px;
		font-size: 10px;
		color: #409EFF;
		font-weight: 600;
		z-index: 9;
	}
	.label_top .el-form-item__label{
		width: 100% !important;
		justify-content: flex-start !important;
		padding-left: 260px;
		box-sizing: border-box;
	}
	.sign_up_container .el-upload-dragger{
		height: 72px !important;
		display: flex;
		justify-content: center;
		align-items: center;
	}
</style>

<style lang="scss" scoped>
	.page-main {
		width: 100%;
		min-height: 100vh;
		background: #F1F1F1;
		display: flex;
		flex-direction: column;
		align-items: center;
		position: relative;

		.pay_tabs {
			display: flex;
			margin-top: 20px;

			.pay_tab {
				font-size: 22px;
				display: flex;
				justify-content: center;
				align-items: center;
				width: 315px;
				height: 90px;
				background-color: #F1F1F1;
				border-radius: 10px;
				position: relative;
				box-sizing: border-box;
				cursor: pointer;
				margin-right: 30px;

				&.actived {
					background-color: #fff;
					border: 2px solid #ff9000;


				}

				.tag {
					background-color: #ff9000;
					width: 30px;
					height: 20px;
					display: flex;
					justify-content: center;
					align-items: center;
					border-radius: 10px 0 10px 0;
					position: absolute;
					right: -2px;
					bottom: -2px;
					box-sizing: border-box;
				}
			}
		}
		
		/deep/.sign_up_container{
			/*复选按钮*/
			.el-checkbox__input.is-checked .el-checkbox__inner, .el-checkbox__input.is-indeterminate .el-checkbox__inner {
			    background-color: #FCA459 !important;
			    border-color: #FCA459 !important;
			}
			
			.el-checkbox__input.is-focus .el-checkbox__inner{
				border-color: #FCA459 !important;
			}
			.el-checkbox__label{
				font-size: 15px;
				//color: #333 !important;
			}
			.el-checkbox__input.is-checked+.el-checkbox__label{
				color: #FCA459 !important;
			}
			
			.el-radio{
				line-height: 2 !important;
			}
			
			.el-collapse{
				border: none !important;
			}
			.el-collapse-item__wrap{
				border: none !important;
			}
			.el-collapse-item__header{
				padding-left: 156px;
				box-sizing: border-box;
				border: none !important;
			}
			
			.pic2_box{
				display: flex;
				flex-direction: column;
				width: 360px; 
				margin-top: 15px;
				
				.pic_box-title{
					font-size: 26upx;
					line-height: 1.75;
					color: #444;
					margin-bottom: 20upx;
				}
				.pic {
					width: 100%;
					height: 72px;
					border: 1px solid #e0e0e0;
					background-color: #fff;
					border-radius: 4px;
					padding: 12px;
					box-sizing: border-box;
					display: flex;
					justify-content: center;
					align-items: center;
					line-height: 1;
					margin-top: 10px;
					
				
					.image_box {
						width: 48px;
						height: 48px;
						margin-right: 12px;
				
						.image {
							width: 48px;
							height: 48px;
							border: 1px solid #eee;
							
							&.file{
								border: none !important;
							}
						}
					}
				
					.info {
						flex: 1;
						height: 38px;
						display: flex;
						flex-direction: column;
						justify-content: space-between;
				
						.title {
							width: 200px;
							font-size: 14px;
							color: #333;
							overflow: hidden;
							text-overflow: ellipsis;
							white-space: nowrap;
							word-break: break-word;
						}
				
						.exts {
							display: flex;
							justify-content: space-between;
							align-items: flex-end;
							
				
							.media_size {
								font-size: 14px;
								color: #999;
							}
				
							.delicon {
								width: 20px;
								cursor: pointer;
							}
						}
					}
				}
				
			}
			
		}
		
		/*
		.sign_up_container {
			/deep/ .el-radio__label {
				font-size: 18px !important;
			}

			/deep/ .el-radio__inner {
				border-radius: 4px !important;
				width: 20px !important;
				height: 20px !important;
				background-color: #fff !important;
			}

			/deep/ .el-radio__inner::after {
				width: 12px !important;
				height: 12px !important;
				border-radius: 4px !important;
				background-color: #999 !important;
			}
			
			
			/deep/ .el-radio__input.is-checked+.el-radio__label {
				color: rgb(153, 153, 153) !important;
			}

			/deep/ .el-checkbox__input.is-checked+.el-checkbox__label {
				color: #666 !important;
			}

			/deep/ .el-checkbox__label {
				font-size: 14px;
			}

			/deep/ .el-checkbox__inner {
				border-radius: 4px !important;
				width: 20px !important;
				height: 20px !important;
				background-color: #fff !important;
			}

			/deep/ .el-checkbox__inner::after {
				width: 12px !important;
				height: 12px !important;
				border-radius: 4px !important;
				background-color: #999 !important;
				box-sizing: content-box;
			}
		}
		*/
	}
</style>